import "../styles/privacy.scss";
function PrivacyPolicy() {
  return (
    <section id="privacy-page" className="hero-area text-black py-4">
      <div id="page-container">
        <div id="pf1" className="pf w0 h0" data-page-no="1">
          <div className="pc pc1 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">1</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h3 y3 ff2 fs1 fc2 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h3 y4 ff2 fs1 fc2 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h4 y5 ff3 fs1 fc2 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h5 y6 ff3 fs2 fc2 sc0 ls0 ws4">
              <span className="fs3 ls2 v1">
                P<span className="_ _0"></span>r<span className="_ _1"></span>
                iva
                <span className="_ _0"></span>cy<span className="_ _1"></span> P
                <span className="_ _2"></span>o<span className="_ _0"></span>li
                <span className="_ _1"></span>c<span className="_ _1"></span>y
                <span className="_ _0"></span>
              </span>
            </div>
            <div className="t m0 x2 h2 y7 ff1 fs0 fc1 sc0 ls2 ws4">
              Last updated: May 11, 2025
            </div>
            <div className="t m0 x2 h2 y8 ff1 fs0 fc1 sc0 ls2 ws4">
              This Privacy Policy describes Our policies and pro
              <span className="_ _2"></span>cedures on the collection, use and d
              <span className="_ _2"></span>isclosure of
            </div>
            <div className="t m0 x2 h2 y9 ff1 fs0 fc1 sc0 ls2 ws4">
              Your information when You u<span className="_ _2"></span>se the
              <span className="_ _0"></span>
              Service and tel<span className="_ _2"></span>ls You about Your
              privacy rights and how t<span className="_ _2"></span>he law
            </div>
            <div className="t m0 x2 h2 ya ff1 fs0 fc1 sc0 ls2 ws4">
              protects You.
            </div>
            <div className="t m0 x2 h2 yb ff1 fs0 fc1 sc0 ls2 ws4">
              We use Your Personal data t<span className="_ _2"></span>o provide
              and improve the Service. By <span className="_ _2"></span>using
              the Service, You agree to
            </div>
            <div className="t m0 x2 h2 yc ff1 fs0 fc1 sc0 ls2 ws4">
              the collection and use of information{" "}
              <span className="_ _2"></span>in accordance with this Privacy
              Policy.
            </div>
            <div className="t m0 x2 h3 yd ff2 fs1 fc2 sc0 ls2 ws4">
              Int<span className="_ _0"></span>e<span className="_ _0"></span>r
              <span className="_ _0"></span>pre<span className="_ _0"></span>
              tati
              <span className="_ _0"></span>o<span className="_ _0"></span>n{" "}
              <span className="_ _0"></span>a<span className="_ _0"></span>n
              <span className="_ _1"></span>d <span className="_ _0"></span>D
              <span className="_ _0"></span>ef<span className="_ _0"></span>i
              <span className="_ _0"></span>ni<span className="_ _1"></span>ti
              <span className="_ _1"></span>on<span className="_ _1"></span>s
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h6 ye ff3 fs4 fc0 sc0 ls2 ws4">
              Interpretatio<span className="_ _0"></span>n
            </div>
            <div className="t m0 x2 h2 yf ff1 fs0 fc1 sc0 ls2 ws4">
              The words of which the initial letter is capitaliz
              <span className="_ _2"></span>ed have meanings defined under the
              following
            </div>
            <div className="t m0 x2 h2 y10 ff1 fs0 fc1 sc0 ls2 ws4">
              conditions. The following definition<span className="_ _2"></span>
              s shall have the same meaning regardless{" "}
              <span className="_ _2"></span>
              of whether they
            </div>
            <div className="t m0 x2 h2 y11 ff1 fs0 fc1 sc0 ls2 ws4">
              appear in singular or in plural.<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h6 y12 ff3 fs4 fc0 sc0 ls2 ws4">
              Definitions
            </div>
            <div className="t m0 x2 h2 y13 ff1 fs0 fc1 sc0 ls2 ws4">
              For the purposes of this Privacy Policy:
            </div>
            <div className="t m0 x3 h2 y14 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Account
                <span className="ff1 ws4">
                  means a unique account created f<span className="_ _2"></span>
                  or You to access our Service or parts of
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y15 ff1 fs0 fc1 sc0 ls2 ws4">
              our Service.
            </div>
            <div className="t m0 x3 h2 y16 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Affiliate
                <span className="ff1 ws4">
                  means an entity that controls, is contro
                  <span className="_ _2"></span>lled by or is under common
                  control
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y17 ff1 fs0 fc1 sc0 ls2 ws4">
              with a party, where &quot;cont<span className="_ _2"></span>
              rol&quot; means ownership of 50% or more of the share
              <span className="_ _2"></span>s, equity
            </div>
            <div className="t m0 x4 h2 y18 ff1 fs0 fc1 sc0 ls2 ws4">
              interest or other securities entitled to vote for elect
              <span className="_ _2"></span>ion of directors or other
            </div>
            <div className="t m0 x4 h2 y19 ff1 fs0 fc1 sc0 ls2 ws4">
              managing authority.
            </div>
            <div className="t m0 x3 h2 y1a ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Application
                <span className="ff1 ws4">
                  means the software pro<span className="_ _2"></span>gram
                  provided by the Company download<span className="_ _2"></span>
                  ed by
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y1b ff1 fs0 fc1 sc0 ls2 ws4">
              You on any electronic dev<span className="_ _2"></span>ice, named
              <span className="_ _0"></span>
              <span className="ff7 fs5 fc3 ws2">
                Church<span className="fc4">Plan</span>
                <span className="ff5 fs6 ws3 v2">®</span>
              </span>
            </div>
            <div className="t m0 x3 h2 y1c ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Business
                <span className="ff1 ws4">
                  , for the purpose of the CCPA (Californ
                  <span className="_ _2"></span>ia Consumer Privacy Act), refers
                  to
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y1d ff1 fs0 fc1 sc0 ls2 ws4">
              the Company as the legal entity t<span className="_ _2"></span>hat
              collects Consumers&apos; personal information
              <span className="_ _2"></span>
              and
            </div>
            <div className="t m0 x4 h2 y1e ff1 fs0 fc1 sc0 ls2 ws4">
              determines the purposes and mean<span className="_ _2"></span>s of
              the processing of Consumers&apos; personal
            </div>
            <div className="t m0 x4 h2 y1f ff1 fs0 fc1 sc0 ls2 ws4">
              information, or on behalf of which
              <span className="_ _2"></span>such<span className="_ _0"></span>
              informatio<span className="_ _2"></span>n is collected and that
              alone, or
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf2" className="pf w0 h0" data-page-no="2">
          <div className="pc pc2 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">2</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x4 h2 y20 ff1 fs0 fc1 sc0 ls2 ws4">
              jointly with others, determines the purpo
              <span className="_ _2"></span>ses and means of the processing of
            </div>
            <div className="t m0 x4 h2 y21 ff1 fs0 fc1 sc0 ls2 ws4">
              consumers&apos; personal info<span className="_ _2"></span>
              rmation, that does business in the State of California.
            </div>
            <div className="t m0 x3 h2 y22 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Charity
                <span className="ff1 ws4">
                  : The organization (Client Charity) tha
                  <span className="_ _2"></span>t subscribes to ChurchPlan®
                  services
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y23 ff1 fs0 fc1 sc0 ls2 ws4">
              (may act as a Data Controller <span className="_ _2"></span>for
              certain data under GDPR).
            </div>
            <div className="t m0 x3 h2 y24 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Church
                <span className="ff1 ws4">
                  : The organization<span className="_ _2"></span> (Client
                  Church) that subscribes to ChurchPlan®
                  <span className="_ _2"></span>services
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y25 ff1 fs0 fc1 sc0 ls2 ws4">
              (may act as a Data Controller <span className="_ _2"></span>for
              certain data under GDPR).
            </div>
            <div className="t m0 x3 h2 y26 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Company
                <span className="ff1 ws4">
                  (referred to as either &quot;t<span className="_ _2"></span>he
                  Com
                  <span className="_ _0"></span>pany&quot;, &quot;W
                  <span className="_ _2"></span>e&quot;, &quot;Us&quot; or
                  &quot;Our&quot; in this
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y27 ff1 fs0 fc1 sc0 ls2 ws4">
              Agreement) refers to <span className="ff6 ws1">ChurchPlan</span>:
            </div>
            <div className="t m0 x4 h2 y28 ff1 fs0 fc1 sc0 ls2 ws4">
              - Acts as a Data Controll<span className="_ _2"></span>er for End
              User account data (directly provided).
            </div>
            <div className="t m0 x4 h2 y29 ff1 fs0 fc1 sc0 ls2 ws4">
              - Acts as a Data Processor for a<span className="_ _2"></span>ny
              data processed on behalf of Client C<span className="_ _2"></span>
              hurches &amp;
            </div>
            <div className="t m0 x4 h2 y2a ff1 fs0 fc1 sc0 ls2 ws4">
              Charities.
            </div>
            <div className="t m0 x4 h2 y2b ff1 fs0 fc1 sc0 ls2 ws4">
              For the purpose of the GDPR, the Company
              <span className="_ _2"></span>is the Data Controller.
            </div>
            <div className="t m0 x3 h2 y2c ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Consumer
                <span className="ff1 ws4">
                  , for the purpose of the CCPA (Cali
                  <span className="_ _2"></span>
                  fornia Consumer Privacy Act), means a
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y2d ff1 fs0 fc1 sc0 ls2 ws4">
              natural person who is a Ca<span className="_ _2"></span>lif
              <span className="_ _0"></span>ornia resident. A{" "}
              <span className="_ _2"></span>resident, as defined in the law,
            </div>
            <div className="t m0 x4 h2 y2e ff1 fs0 fc1 sc0 ls2 ws4">
              includes (1) every individual who is{" "}
              <span className="_ _2"></span>in the USA for other than a
              temporary or
            </div>
            <div className="t m0 x4 h2 y2f ff1 fs0 fc1 sc0 ls2 ws4">
              transitory purpose, and (2) every
              <span className="_ _2"></span>indi<span className="_ _0"></span>
              vidual who is<span className="_ _2"></span> domiciled in the USA
              who is
            </div>
            <div className="t m0 x4 h2 y30 ff1 fs0 fc1 sc0 ls2 ws4">
              outside the USA for a temporary <span className="_ _2"></span>or
              transitory purpose.
            </div>
            <div className="t m0 x3 h2 y31 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Country
                <span className="ff1 ws4">
                  refers to: Ontari<span className="_ _2"></span>o, Canada.
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y32 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Data Controller
                  <span className="ff1">
                    , for the purposes of the GDPR (Gen
                    <span className="_ _2"></span>eral Data Protection
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y33 ff1 fs0 fc1 sc0 ls2 ws4">
              Regulation), refers to the Company <span className="_ _2"></span>
              as the legal entity which alone or jointly with
            </div>
            <div className="t m0 x4 h2 y34 ff1 fs0 fc1 sc0 ls2 ws4">
              others determines the purposes and <span className="_ _2"></span>
              means of the processing of Personal Data.
            </div>
            <div className="t m0 x3 h2 y35 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Data Processor:
                  <span className="ff1">
                    The entity <span className="_ _2"></span>that proc
                    <span className="_ _0"></span>esses pers
                    <span className="_ _2"></span>onal data on behalf of the
                    Data
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y36 ff1 fs0 fc1 sc0 ls2 ws4">
              Controller
            </div>
            <div className="t m0 x3 h2 y37 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Device
                <span className="ff1 ws4">
                  means any device that can a<span className="_ _2"></span>ccess
                  the Service such as a computer, a
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y38 ff1 fs0 fc1 sc0 ls2 ws4">
              cellphone or a digital tablet.
            </div>
            <div className="t m0 x3 h2 y39 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Do Not Track
                  <span className="ff1">
                    (DNT) is a concept that h<span className="_ _2"></span>as
                    been promoted by US regulatory
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y3a ff1 fs0 fc1 sc0 ls2 ws4">
              authorities, in particular t<span className="_ _2"></span>he U.S.
              Fede
              <span className="_ _0"></span>ral Trad
              <span className="_ _2"></span>e Commission (FTC), for the Int
              <span className="_ _2"></span>ernet
            </div>
            <div className="t m0 x4 h2 y3b ff1 fs0 fc1 sc0 ls2 ws4">
              industry to develop and implement <span className="_ _2"></span>a
              mechanism for allowing int<span className="_ _2"></span>ernet
              users to
            </div>
            <div className="t m0 x4 h2 y3c ff1 fs0 fc1 sc0 ls2 ws4">
              control the tracking of their online activities acros
              <span className="_ _2"></span>s websites
              <span className="_ _0"></span>.
            </div>
            <div className="t m0 x3 h2 y3d ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  End User
                  <span className="ff1">
                    : Individuals who create personal account
                    <span className="_ _2"></span>s directly in ChurchPlan®
                    (e.g.,
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y3e ff1 fs0 fc1 sc0 ls2 ws4">
              congregants, volunteers). They are
              <span className="ff6">Data Subjects</span> under GDPR and contro
              <span className="_ _2"></span>l their
            </div>
            <div className="t m0 x4 h2 y3f ff1 fs0 fc1 sc0 ls2 ws4">
              own data.
            </div>
            <div className="t m0 x3 h2 y40 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Personal Data
                  <span className="ff1">
                    is any information that relate<span className="_ _2"></span>
                    s to an identified or identifiable
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y41 ff1 fs0 fc1 sc0 ls2 ws4">
              individual.
            </div>
            <div className="t m0 x4 h2 y42 ff1 fs0 fc1 sc0 ls2 ws4">
              For the purposes for GDPR, Personal Data mean
              <span className="_ _2"></span>s any information relating to You
            </div>
            <div className="t m0 x4 h2 y43 ff1 fs0 fc1 sc0 ls2 ws4">
              such as a name, an ident<span className="_ _2"></span>ificatio
              <span className="_ _0"></span>n number, lo
              <span className="_ _2"></span>
              cation data, online identifier or to one or
            </div>
            <div className="t m0 x4 h2 y44 ff1 fs0 fc1 sc0 ls2 ws4">
              more factors specific to the physical, physiol
              <span className="_ _2"></span>ogical, genetic, mental, economic
              <span className="_ _2"></span>,
            </div>
            <div className="t m0 x4 h2 y45 ff1 fs0 fc1 sc0 ls2 ws4">
              cultural or social identity.
            </div>
            <div className="t m0 x4 h2 y46 ff1 fs0 fc1 sc0 ls2 ws4">
              For the purposes of the CCPA, Pers<span className="_ _2"></span>
              onal Data means any information that iden
              <span className="_ _2"></span>
              tifies,
            </div>
            <div className="t m0 x4 h2 y47 ff1 fs0 fc1 sc0 ls2 ws4">
              relates to, describes or is capable of bein
              <span className="_ _2"></span>g associated with, or could
              reasonably <span className="_ _2"></span>be
            </div>
            <div className="t m0 x4 h2 y48 ff1 fs0 fc1 sc0 ls2 ws4">
              linked, directly or indirectly, with You.
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf3" className="pf w0 h0" data-page-no="3">
          <div className="pc pc3 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">3</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x3 h2 y49 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Privacy Officer
                  <span className="ff1">
                    (or Data Protection Officer) is the
                    <span className="_ _2"></span>designated individual
                    responsible
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y4a ff1 fs0 fc1 sc0 ls2 ws4">
              for overseeing the Company&apos;s data protect
              <span className="_ _2"></span>ion strategy and compliance with
              privacy
            </div>
            <div className="t m0 x4 h2 y22 ff1 fs0 fc1 sc0 ls2 ws4">
              laws and regulations (such as PIPEDA, GDPR, CCPA
              <span className="_ _2"></span>or CPRA).
            </div>
            <div className="t m0 x3 h2 y4b ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Sale
                <span className="ff1 ws4">
                  : For the purpose of the CCPA (Cali
                  <span className="_ _2"></span>
                  fornia Consumer Privacy Act), means sell
                  <span className="_ _2"></span>ing,
                  <span className="_ _0"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y24 ff1 fs0 fc1 sc0 ls2 ws4">
              renting, releasing, disclosing, disseminating,
              <span className="_ _2"></span>making available, transferrin
              <span className="_ _2"></span>g<span className="_ _0"></span>, or
            </div>
            <div className="t m0 x4 h2 y25 ff1 fs0 fc1 sc0 ls2 ws4">
              otherwise communicating orally, in writing
              <span className="_ _2"></span>, or by electronic or other means, a
            </div>
            <div className="t m0 x4 h2 y4c ff1 fs0 fc1 sc0 ls2 ws4">
              Consumer&apos;s personal information to an
              <span className="_ _2"></span>other business or a third party for
              mo
              <span className="_ _2"></span>netary
            </div>
            <div className="t m0 x4 h2 y4d ff1 fs0 fc1 sc0 ls2 ws4">
              or other valuable consideration.
            </div>
            <div className="t m0 x3 h2 y28 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Service
                <span className="ff1 ws4">refers to the Application.</span>
              </span>
            </div>
            <div className="t m0 x3 h2 y4e ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Service Provider
                  <span className="ff1">
                    means any natural or le<span className="_ _2"></span>gal
                    person who processes the data on
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y4f ff1 fs0 fc1 sc0 ls2 ws4">
              behalf of the Company. It refers to third-party comp
              <span className="_ _2"></span>anies or individuals employed
            </div>
            <div className="t m0 x4 h2 y50 ff1 fs0 fc1 sc0 ls2 ws4">
              by the Company to facilitate the Serv
              <span className="_ _2"></span>
              ice, to provide the Service on behalf of the
            </div>
            <div className="t m0 x4 h2 y2c ff1 fs0 fc1 sc0 ls2 ws4">
              Company, to perform services related to th
              <span className="_ _2"></span>e Service or to assist the Company i
              <span className="_ _2"></span>n
            </div>
            <div className="t m0 x4 h2 y2d ff1 fs0 fc1 sc0 ls2 ws4">
              analyzing how the Service<span className="_ _2"></span> is used.
              For the purpose of the GDPR, Service Providers
            </div>
            <div className="t m0 x4 h2 y2e ff1 fs0 fc1 sc0 ls2 ws4">
              are considered Data Processor<span className="_ _2"></span>s.
            </div>
            <div className="t m0 x3 h2 y51 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Third-party Social Media<span className="_ _2"></span> Service
                  <span className="_ _0"></span>
                  <span className="ff1">
                    refers to any website or an<span className="_ _2"></span>y
                    social network
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y52 ff1 fs0 fc1 sc0 ls2 ws4">
              website through which a User can log in or create a
              <span className="_ _2"></span>n account to use the Service.
            </div>
            <div className="t m0 x3 h2 y53 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  Usage Data
                  <span className="ff1">
                    refers to data collected auto<span className="_ _2"></span>
                    matically, either generated by the use of t
                    <span className="_ _2"></span>he
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y32 ff1 fs0 fc1 sc0 ls2 ws4">
              Service or from the Service infrastruct
              <span className="_ _2"></span>
              ure itself (for example, the duration of a
              <span className="_ _2"></span>
              page
            </div>
            <div className="t m0 x4 h2 y33 ff1 fs0 fc1 sc0 ls2 ws4">
              visit).
            </div>
            <div className="t m0 x3 h2 y54 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                You
                <span className="ff1 ws4">
                  means the individual <span className="_ _2"></span>accessing
                  or using the Service, or the company, or other
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y35 ff1 fs0 fc1 sc0 ls2 ws4">
              legal entity on behalf of which such ind
              <span className="_ _2"></span>
              ividual is accessing or using the Service, as
            </div>
            <div className="t m0 x4 h2 y36 ff1 fs0 fc1 sc0 ls2 ws4">
              applicable.
            </div>
            <div className="t m0 x4 h2 y55 ff1 fs0 fc1 sc0 ls2 ws4">
              Under GDPR (General Data Protect<span className="_ _2"></span>ion
              Regulation), You can be referred to as t
              <span className="_ _2"></span>
              he
            </div>
            <div className="t m0 x4 h2 y56 ff1 fs0 fc1 sc0 ls2 ws4">
              Data Subject or as the User as you are the ind
              <span className="_ _2"></span>ividual using the Service.
            </div>
            <div className="t m0 x2 h3 y57 ff2 fs1 fc2 sc0 ls2 ws4">
              Co<span className="_ _0"></span>l<span className="_ _0"></span>l
              <span className="_ _0"></span>e<span className="_ _1"></span>ct
              <span className="_ _1"></span>i<span className="_ _0"></span>ng
              <span className="_ _1"></span> a<span className="_ _0"></span>n
              <span className="_ _0"></span>d <span className="_ _1"></span>U
              <span className="_ _0"></span>si<span className="_ _0"></span>n
              <span className="_ _1"></span>g<span className="_ _0"></span>
              <span className="_ _0"></span>Y<span className="_ _3"></span>o
              <span className="_ _0"></span>ur<span className="_ _1"></span> Pe
              <span className="_ _0"></span>rson<span className="_ _0"></span>a
              <span className="_ _0"></span>l<span className="_ _0"></span>
              <span className="_ _0"></span>Da<span className="_ _0"></span>ta
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h6 y58 ff3 fs4 fc0 sc0 ls2 ws4">
              Types of Da<span className="_ _0"></span>ta Collecte
              <span className="_ _0"></span>d:
            </div>
            <div className="t m0 x2 h6 y59 ff3 fs4 fc0 sc0 ls2 ws4">
              A. Data Prov<span className="_ _0"></span>ided Direct
              <span className="_ _0"></span>ly by End
              <span className="_ _0"></span> Users:
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x5 h2 y5a ff6 fs0 fc1 sc0 ls2 ws4">
              Types of Data:
              <span className="ff1">
                First &amp; Last Name, Date of Birth, Ge
                <span className="_ _2"></span>nder, Martial Status, email
                address,
              </span>
            </div>
            <div className="t m0 x5 h2 y5b ff1 fs0 fc1 sc0 ls2 ws4">
              phone number, address, p<span className="_ _2"></span>ayment
              details (if applicable), profile pictures, and{" "}
              <span className="_ _2"></span>
              other account
            </div>
            <div className="t m0 x5 h2 y5c ff1 fs0 fc1 sc0 ls2 ws4">
              information.
            </div>
            <div className="t m0 x5 h2 y5d ff6 fs0 fc1 sc0 ls2 ws1">
              Purpose:
              <span className="ff1 ws4">
                To provide and personalize ChurchPlan®
                <span className="_ _2"></span>
                services, facilitate logins, and enable
              </span>
            </div>
            <div className="t m0 x5 h2 y5e ff1 fs0 fc1 sc0 ls2 ws4">
              features (e.g., event sign-ups, donat
              <span className="_ _2"></span>
              ions).
            </div>
            <div className="t m0 x5 h2 y5f ff6 fs0 fc1 sc0 ls2 ws4">
              Legal Basis (GDPR):
            </div>
            <div className="t m0 x5 h2 y60 ff1 fs0 fc1 sc0 ls2 ws4">
              Consent (for account creat<span className="_ _2"></span>ion).
            </div>
            <div className="t m0 x5 h2 y61 ff1 fs0 fc1 sc0 ls2 ws4">
              Contractual necessity (to maintain user a
              <span className="_ _2"></span>ccounts).
            </div>
            <div className="t m0 x5 h2 y62 ff1 fs0 fc1 sc0 ls2 ws4">
              CCPA/CPRA: No &quot;sale&quot; of p<span className="_ _2"></span>
              ersonal data.
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf4" className="pf w0 h0" data-page-no="4">
          <div className="pc pc4 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">4</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y63 ff3 fs4 fc0 sc0 ls2 ws4">
              B. Data Proc<span className="_ _0"></span>essed for
              <span className="_ _0"></span>Client Chur
              <span className="_ _0"></span>
              ches/Cha<span className="_ _0"></span>rities:
            </div>
            <div className="t m0 x5 h2 y64 ff6 fs0 fc1 sc0 ls2 ws4">
              Types of Data:
              <span className="ff1">
                Attendanc<span className="_ _2"></span>e reco
                <span className="_ _0"></span>rds, Services sub
                <span className="_ _2"></span>scription, group memberships, or
                other
              </span>
            </div>
            <div className="t m0 x5 h2 y65 ff1 fs0 fc1 sc0 ls2 ws4">
              data managed by the Chur<span className="_ _2"></span>ch (if
              applicable).
            </div>
            <div className="t m0 x5 h2 y66 ff6 fs0 fc1 sc0 ls2 ws1">
              Purpose:
              <span className="ff1 ws4">
                To fulfill the Client Church’s admini
                <span className="_ _2"></span>
                strative needs (e.g., member tracking, event
              </span>
            </div>
            <div className="t m0 x5 h2 y67 ff1 fs0 fc1 sc0 ls2 ws4">
              management, pastoral care).
            </div>
            <div className="t m0 x5 h2 y68 ff6 fs0 fc1 sc0 ls2 ws4">
              Legal Basis (GDPR):
            </div>
            <div className="t m0 x5 h2 y69 ff1 fs0 fc1 sc0 ls2 ws4">
              Legitimate interest (for operational use by
              <span className="_ _2"></span>the Church/Charity).
            </div>
            <div className="t m0 x5 h2 y6a ff1 fs0 fc1 sc0 ls2 ws4">
              Consent (if required by the Church’s policie
              <span className="_ _2"></span>s).
            </div>
            <div className="t m0 x2 h6 y6b ff3 fs4 fc0 sc0 ls2 ws4">
              C. Automa<span className="_ _0"></span>tically Coll
              <span className="_ _0"></span>ected Data:
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x5 h2 y6c ff6 fs0 fc1 sc0 ls2 ws1">
              Types:
              <span className="ff1 ws4">
                Cookies, device info, IP addresses, usage ana
                <span className="_ _2"></span>lytics (Google Analytics).
              </span>
            </div>
            <div className="t m0 x5 h2 y6d ff6 fs0 fc1 sc0 ls2 ws1">
              Purpose:
              <span className="ff1 ws4">
                Security, fraud prevention, and service
                <span className="_ _2"></span>improvement.
              </span>
            </div>
            <div className="t m0 x5 h2 y6e ff6 fs0 fc1 sc0 ls2 ws1">
              Opt-Out:
              <span className="ff1 ws4">
                Available via browser settings or our cook
                <span className="_ _2"></span>ie policy.
              </span>
            </div>
            <div className="t m0 x2 h6 y6f ff3 fs4 fc0 sc0 ls2 ws4">
              Usage Data<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y70 ff1 fs0 fc1 sc0 ls2 ws4">
              Usage Data is collected au<span className="_ _2"></span>
              tomatically when using the Service.
            </div>
            <div className="t m0 x2 h2 y71 ff1 fs0 fc1 sc0 ls2 ws4">
              Usage Data may include information <span className="_ _2"></span>
              such as Your Device&apos;s Internet Prot
              <span className="_ _2"></span>ocol address (e.g. IP
            </div>
            <div className="t m0 x2 h2 y72 ff1 fs0 fc1 sc0 ls2 ws4">
              address), browser type, browser version, the pa
              <span className="_ _2"></span>ges of our Service that You vi
              <span className="_ _2"></span>sit, the time and date
            </div>
            <div className="t m0 x2 h2 y73 ff1 fs0 fc1 sc0 ls2 ws4">
              of Your visit, the time spent<span className="_ _2"></span> on
              those pages, unique device identifiers and other
              <span className="_ _2"></span>diagnostic data.
            </div>
            <div className="t m0 x2 h2 y74 ff1 fs0 fc1 sc0 ls2 ws4">
              When You access the Service by or through a
              <span className="_ _2"></span>mobile device, We may
              <span className="_ _2"></span>collec<span className="_ _0"></span>
              t certain information
            </div>
            <div className="t m0 x2 h2 y75 ff1 fs0 fc1 sc0 ls2 ws4">
              automatically, including, <span className="_ _2"></span>but not
              limited to, the type of mobile device You u
              <span className="_ _2"></span>se, Your mobile device
            </div>
            <div className="t m0 x2 h2 y76 ff1 fs0 fc1 sc0 ls2 ws4">
              unique ID, the IP address of Your mobile devi
              <span className="_ _2"></span>ce, Your mobile operating system,
              the type of mob<span className="_ _2"></span>ile
            </div>
            <div className="t m0 x2 h2 y77 ff1 fs0 fc1 sc0 ls2 ws4">
              Internet browser You use, unique device identifi
              <span className="_ _2"></span>ers and other diagnostic data.
            </div>
            <div className="t m0 x2 h2 y78 ff1 fs0 fc1 sc0 ls2 ws4">
              We may also collect information that Your brow
              <span className="_ _2"></span>ser sends whenever You visit our
              Service or when
            </div>
            <div className="t m0 x2 h2 y79 ff1 fs0 fc1 sc0 ls2 ws4">
              You access the Service by <span className="_ _2"></span>or through
              a mobile device.
            </div>
            <div className="t m0 x2 h6 y7a ff3 fs4 fc0 sc0 ls2 ws4">
              Information<span className="_ _0"></span> from Third-P
              <span className="_ _0"></span>arty Social
              <span className="_ _0"></span> Media S
              <span className="_ _0"></span>ervices
            </div>
            <div className="t m0 x2 h2 y7b ff1 fs0 fc1 sc0 ls2 ws4">
              The Company allows You to create an<span className="_ _2"></span>
              account and log in to use the Service th
              <span className="_ _2"></span>
              rough the following
            </div>
            <div className="t m0 x2 h2 y7c ff1 fs0 fc1 sc0 ls2 ws4">
              Third-party Social Media Servi<span className="_ _2"></span>ces:
            </div>
            <div className="t m0 x2 h2 y7d ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Apple </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y7e ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Google </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y7f ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Facebook </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y80 ff1 fs0 fc1 sc0 ls2 ws4">
              If You decide to register through or otherwi
              <span className="_ _2"></span>se grant us access to a Third-Party
              <span className="_ _2"></span>Social<span className="_ _0"></span>{" "}
              Media Service,
            </div>
            <div className="t m0 x2 h2 y81 ff1 fs0 fc1 sc0 ls2 ws4">
              We may collect Personal data that i<span className="_ _2"></span>s
              already associated with Your Third-Party Social Media
            </div>
            <div className="t m0 x2 h2 y82 ff1 fs0 fc1 sc0 ls2 ws4">
              Service&apos;s account, such as Your name, Your
              <span className="_ _2"></span>email address, Your activities or
              Your con<span className="_ _2"></span>tact list
            </div>
            <div className="t m0 x2 h2 y83 ff1 fs0 fc1 sc0 ls2 ws4">
              associated with that account.
            </div>
            <div className="t m0 x2 h2 y84 ff1 fs0 fc1 sc0 ls2 ws4">
              You may also have the option of <span className="_ _2"></span>sh
              <span className="_ _0"></span>aring addit
              <span className="_ _2"></span>
              ional information with the Comp<span className="_ _2"></span>any
              through Your
            </div>
            <div className="t m0 x2 h2 y85 ff1 fs0 fc1 sc0 ls2 ws4">
              Third-Party Social Media Servi<span className="_ _2"></span>
              ce&apos;s
              <span className="_ _0"></span> account. If Yo
              <span className="_ _2"></span>u choose to provide such information
              and Personal
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf5" className="pf w0 h0" data-page-no="5">
          <div className="pc pc5 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">5</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y20 ff1 fs0 fc1 sc0 ls2 ws4">
              Data, during registration or otherwise,
              <span className="_ _2"></span>You are giving the Company
              permission to use, share, and
            </div>
            <div className="t m0 x2 h2 y21 ff1 fs0 fc1 sc0 ls2 ws4">
              store it in a manner consistent with this Privacy Pol
              <span className="_ _2"></span>icy.
            </div>
            <div className="t m0 x2 h6 y86 ff3 fs4 fc0 sc0 ls2 ws4">
              Information<span className="_ _0"></span> Collecte
              <span className="_ _0"></span>d whil<span className="_ _0"></span>
              e Using the Appli<span className="_ _0"></span>cation
            </div>
            <div className="t m0 x2 h2 y87 ff1 fs0 fc1 sc0 ls2 ws4">
              While using Our Application<span className="_ _2"></span>, in
              order
              <span className="_ _0"></span>
              to pr<span className="_ _2"></span>ovide features of Our
              Application, We may collect, w<span className="_ _2"></span>ith
            </div>
            <div className="t m0 x2 h2 y88 ff1 fs0 fc1 sc0 ls2 ws4">
              Your prior permission:
            </div>
            <div className="t m0 x5 h2 y89 ff1 fs0 fc1 sc0 ls2 ws4">
              Information regarding your location<span className="_ _2"></span>
            </div>
            <div className="t m0 x5 h2 y8a ff1 fs0 fc1 sc0 ls2 ws4">
              Pictures and other information from you
              <span className="_ _2"></span>r Device&apos;s camera and photo
              library
            </div>
            <div className="t m0 x2 h2 y8b ff1 fs0 fc1 sc0 ls2 ws4">
              We use this information to p<span className="_ _2"></span>rovide
              features of Our Service, to improve and custo
              <span className="_ _2"></span>mize Our Service.
            </div>
            <div className="t m0 x2 h2 y8c ff1 fs0 fc1 sc0 ls2 ws4">
              The information may be u<span className="_ _2"></span>ploaded to
              the Company&apos;s servers and/or a Servi
              <span className="_ _2"></span>ce Provider&apos;s server or it
            </div>
            <div className="t m0 x2 h2 y8d ff1 fs0 fc1 sc0 ls2 ws4">
              may be simply stored on Your devi<span className="_ _2"></span>ce.
            </div>
            <div className="t m0 x2 h2 y8e ff1 fs0 fc1 sc0 ls2 ws4">
              You can enable or disable access to t
              <span className="_ _2"></span>his information at any t
              <span className="_ _2"></span>ime,
              <span className="_ _0"></span>
              through Your<span className="_ _2"></span> Device settings.
            </div>
            <div className="t m0 x2 h6 y8f ff3 fs4 fc0 sc0 ls2 ws4">
              Use of Your P<span className="_ _0"></span>ersonal
              <span className="_ _0"></span>
              Data
            </div>
            <div className="t m0 x2 h2 y90 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company may use Personal Data for t
              <span className="_ _2"></span>
              he following purposes:
            </div>
            <div className="t m0 x2 h2 y91 ff6 fs0 fc1 sc0 ls2 ws4">
              To provide and mai<span className="_ _2"></span>ntain our Service
              <span className="_ _0"></span>
              <span className="ff1">: </span>
            </div>
            <div className="t m0 x2 h2 y92 ff1 fs0 fc1 sc0 ls2 ws4">
              Your personal informatio<span className="_ _2"></span>n is
              collected and processed solely to support the op
              <span className="_ _2"></span>
              erational and/or
            </div>
            <div className="t m0 x2 h2 y93 ff1 fs0 fc1 sc0 ls2 ws4">
              religious mission of the Client Ch<span className="_ _2"></span>
              urch/Charity including but not limited to:
            </div>
            <div className="t m0 x5 h2 y94 ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Administration of memb<span className="_ _2"></span>ership
                  records:
                  <span className="ff1">
                    Maintaining an updated directory of
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y95 ff1 fs0 fc1 sc0 ls2 ws4">
              congregation members.<span className="ff6"> </span>
            </div>
            <div className="t m0 x5 h2 y96 ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Pastoral Care &amp; Spiritual<span className="_ _2"></span>
                  Support<span className="_ _0"></span>
                  <span className="ff1">
                    : Providing counseling, prayer re
                    <span className="_ _2"></span>
                    quests, and
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y97 ff1 fs0 fc1 sc0 ls2 ws4">
              spiritual guidance.
            </div>
            <div className="t m0 x5 h2 y98 ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Donation Management
                  <span className="ff1">
                    : Processing donations, off<span className="_ _2"></span>
                    erings, and issuing tax receipts.
                    <span className="_ _2"></span>{" "}
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y99 ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Event Coordination
                  <span className="ff1">
                    : Facilitating regi<span className="_ _2"></span>stration,
                    attendance tracking, and logisti
                    <span className="_ _2"></span>
                    cal
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y9a ff1 fs0 fc1 sc0 ls2 ws4">
              planning for Church/Charity events.<span className="_ _2"></span>
            </div>
            <div className="t m0 x5 h2 y9b ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Church Communications
                  <span className="ff1">
                    : Sharing updates about <span className="_ _2"></span>
                    services, sermons, liturgies,
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y9c ff1 fs0 fc1 sc0 ls2 ws4">
              ministries, and community <span className="_ _2"></span>outreach.
            </div>
            <div className="t m0 x5 h2 y9d ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Volunteer &amp; Ministry O<span className="_ _2"></span>
                  perations
                  <span className="_ _0"></span>
                  <span className="ff1">
                    : Screening, scheduling, and support
                    <span className="_ _2"></span>ing volunteers
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y9e ff1 fs0 fc1 sc0 ls2 ws4">
              and ministry programs.<span className="_ _2"></span>
            </div>
            <div className="t m0 x5 h2 y9f ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Child &amp; Youth Safety
                  <span className="ff1">
                    : Administerin<span className="_ _2"></span>g
                    <span className="_ _0"></span>
                    programs wit<span className="_ _2"></span>h appropriate
                    safeguards for minors.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 ya0 ff8 fs0 fc1 sc0 ls2 ws0">
              o
              <span className="ff5 ls3 ws4">
                <span className="ff6 ls2">
                  Sacramental Recordkee<span className="_ _2"></span>ping
                  <span className="_ _0"></span>
                  <span className="ff1">
                    : Preserving historical records of baptis
                    <span className="_ _2"></span>ms, marriages,
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 ya1 ff1 fs0 fc1 sc0 ls2 ws4">
              and other rites.
            </div>
            <div className="t m0 x2 h2 ya2 ff1 fs0 fc1 sc0 ls2 ws4">
              All data is handled in ac<span className="_ _2"></span>cordance
              <span className="_ _0"></span>
              with our Privacy <span className="_ _2"></span>Policy and
              applicable data protection laws.
            </div>
            <div className="t m0 x2 h2 ya3 ff6 fs0 fc1 sc0 ls2 ws4">
              To manage Your Accou<span className="_ _2"></span>nt:
              <span className="_ _0"></span>
              <span className="ff1">
                to manage Your re<span className="_ _2"></span>gistration as a
                user of the Service. The Personal Data
              </span>
            </div>
            <div className="t m0 x2 h2 ya4 ff1 fs0 fc1 sc0 ls2 ws4">
              You provide can give You access to d<span className="_ _2"></span>
              ifferent functionalities of the Service that
              <span className="_ _2"></span>are avail
              <span className="_ _0"></span>able to Y
              <span className="_ _2"></span>ou
            </div>
            <div className="t m0 x2 h2 ya5 ff1 fs0 fc1 sc0 ls2 ws4">
              as a registered user.
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf6" className="pf w0 h0" data-page-no="6">
          <div className="pc pc6 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">6</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y20 ff6 fs0 fc1 sc0 ls2 ws4">
              For the performance of <span className="_ _2"></span>a contract:
              <span className="_ _0"></span>
              <span className="ff1">
                the development, compliance and
                <span className="_ _2"></span>undertaking of the purchase
              </span>
            </div>
            <div className="t m0 x2 h2 y21 ff1 fs0 fc1 sc0 ls2 ws4">
              contract for the products, ite<span className="_ _2"></span>ms or
              <span className="_ _0"></span>
              <span className="_ _2"></span>ser<span className="_ _0"></span>
              vices You have p<span className="_ _2"></span>urchased or of any
              other contract with Us
            </div>
            <div className="t m0 x2 h2 ya6 ff1 fs0 fc1 sc0 ls2 ws4">
              through the Service.
            </div>
            <div className="t m0 x2 h2 ya7 ff6 fs0 fc1 sc0 ls2 ws4">
              To contact You:
              <span className="ff1">
                To contact You by <span className="_ _2"></span>email, telephone
                calls, SMS, or other equivalent forms of
              </span>
            </div>
            <div className="t m0 x2 h2 ya8 ff1 fs0 fc1 sc0 ls2 ws4">
              electronic communication, such as a mobile app
              <span className="_ _2"></span>lication&apos;s push notifications
              regarding update<span className="_ _2"></span>s or
            </div>
            <div className="t m0 x2 h2 ya9 ff1 fs0 fc1 sc0 ls2 ws4">
              informative communications relat<span className="_ _2"></span>ed
              to the functionalities, products or contracted
              <span className="_ _2"></span>services,
            </div>
            <div className="t m0 x2 h2 yaa ff1 fs0 fc1 sc0 ls2 ws4">
              including the security updates, w<span className="_ _2"></span>hen
              necessary or reasonable for their imple
              <span className="_ _2"></span>
              mentation.
            </div>
            <div className="t m0 x2 h2 yab ff6 fs0 fc1 sc0 ls2 ws4">
              To provide You
              <span className="ff1">
                with news, special offers and gen<span className="_ _2"></span>
                eral information about other goods, services and
              </span>
            </div>
            <div className="t m0 x2 h2 yac ff1 fs0 fc1 sc0 ls2 ws4">
              events which we offer that are similar to those that
              <span className="_ _2"></span>you have already purchased or
              enquire
              <span className="_ _2"></span>d about
            </div>
            <div className="t m0 x2 h2 yad ff1 fs0 fc1 sc0 ls2 ws4">
              unless You have opted not<span className="_ _2"></span> to receive
              such information.
            </div>
            <div className="t m0 x2 h2 yae ff6 fs0 fc1 sc0 ls2 ws4">
              To manage Your reques<span className="_ _2"></span>ts:
              <span className="_ _0"></span>
              <span className="ff1">
                To attend and manage <span className="_ _2"></span>Your requests
                to Us.
              </span>
            </div>
            <div className="t m0 x2 h2 yaf ff6 fs0 fc1 sc0 ls2 ws4">
              For business transfers:
              <span className="ff1">
                We may use Your inform<span className="_ _2"></span>ation to
                evaluate or conduct<span className="_ _2"></span> a merger,
              </span>
            </div>
            <div className="t m0 x2 h2 yb0 ff1 fs0 fc1 sc0 ls2 ws4">
              divestiture, restructuring, reorganization, disso
              <span className="_ _2"></span>lution, or other sale or transfer of
              some or all
              <span className="_ _2"></span>of Our
            </div>
            <div className="t m0 x2 h2 yb1 ff1 fs0 fc1 sc0 ls2 ws4">
              assets, whether as a going concern or as part
              <span className="_ _2"></span>of bankruptcy
              <span className="_ _0"></span>, liq<span className="_ _2"></span>
              uidatio<span className="_ _0"></span>n, or si
              <span className="_ _2"></span>milar proceeding, in
            </div>
            <div className="t m0 x2 h2 yb2 ff1 fs0 fc1 sc0 ls2 ws4">
              which Personal Data held by Us about our
              <span className="_ _2"></span>Service users is among the assets t
              <span className="_ _2"></span>ransferred.
            </div>
            <div className="t m0 x2 h2 yb3 ff6 fs0 fc1 sc0 ls2 ws4">
              For other purposes
              <span className="ff1">
                : We may use Your infor<span className="_ _2"></span>mation for
                other purposes, such as data analysi
                <span className="_ _2"></span>s,
              </span>
            </div>
            <div className="t m0 x2 h2 yb4 ff1 fs0 fc1 sc0 ls2 ws4">
              identifying usage trends, determining the
              <span className="_ _2"></span>effectiveness of our promotional
              campaigns and to
            </div>
            <div className="t m0 x2 h2 yb5 ff1 fs0 fc1 sc0 ls2 ws4">
              evaluate and improve our<span className="_ _2"></span> Service,
              products, services, marketing and your e
              <span className="_ _2"></span>
              xperience.
            </div>
            <div className="t m0 x2 h2 yb6 ff1 fs0 fc1 sc0 ls2 ws4">
              We may share Your personal infor<span className="_ _2"></span>
              mation in the following situations:
            </div>
            <div className="t m0 x2 h2 yb7 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  With Service Providers:
                  <span className="ff1">
                    We may sha<span className="_ _2"></span>re Your personal
                    information with Service Providers to
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 yb8 ff1 fs0 fc1 sc0 ls2 ws4">
              monitor and analyze the u<span className="_ _2"></span>se of our
              Service, for payment processing, to contact You.
            </div>
            <div className="t m0 x2 h2 yb9 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  For business transfers:
                  <span className="ff1">
                    We may share or tran<span className="_ _2"></span>sfer Your
                    personal information<span className="_ _2"></span> in
                    connection
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 yba ff1 fs0 fc1 sc0 ls2 ws4">
              with, or during negotiations of, any merger, s
              <span className="_ _2"></span>ale of Company assets, financing, or
              acquisition of
            </div>
            <div className="t m0 x6 h2 ybb ff1 fs0 fc1 sc0 ls2 ws4">
              all or a portion of Our busines<span className="_ _2"></span>s to
              another company.
            </div>
            <div className="t m0 x2 h2 ybc ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  With Affiliates:
                  <span className="ff1">
                    We may share Your information <span className="_ _2"></span>
                    with Our affiliates, in which case we will
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 ybd ff1 fs0 fc1 sc0 ls2 ws4">
              require those affiliates to honor this Pr
              <span className="_ _2"></span>ivacy Policy. Affiliates include Our
              parent
              <span className="_ _2"></span>company and
            </div>
            <div className="t m0 x6 h2 ybe ff1 fs0 fc1 sc0 ls2 ws4">
              any other subsidiaries, joint venture partners or ot
              <span className="_ _2"></span>her companies that We con
              <span className="_ _2"></span>trol or that are
            </div>
            <div className="t m0 x6 h2 ybf ff1 fs0 fc1 sc0 ls2 ws4">
              under common control wi<span className="_ _2"></span>th Us.
            </div>
            <div className="t m0 x2 h2 yc0 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  With other users:
                  <span className="ff1">
                    when You share personal <span className="_ _2"></span>
                    information or otherwise interact in the p
                    <span className="_ _2"></span>ublic
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 yc1 ff1 fs0 fc1 sc0 ls2 ws4">
              areas with other users, such infor<span className="_ _2"></span>
              mation may be viewed by all users and may b
              <span className="_ _2"></span>e public
              <span className="_ _0"></span>ly
            </div>
            <div className="t m0 x6 h2 yc2 ff1 fs0 fc1 sc0 ls2 ws4">
              distributed outside. If You interact with other user
              <span className="_ _2"></span>s or register through a Third-Party
              Soc
              <span className="_ _2"></span>ial
            </div>
            <div className="t m0 x6 h2 yc3 ff1 fs0 fc1 sc0 ls2 ws4">
              Media Service, Your contacts on th<span className="_ _2"></span>e
              Third-Party Social Media Service may see Your name,
            </div>
            <div className="t m0 x6 h2 yc4 ff1 fs0 fc1 sc0 ls2 ws4">
              profile, pictures and description o<span className="_ _2"></span>f
              Your activity. Similarly, other users will be ab
              <span className="_ _2"></span>le to view
            </div>
            <div className="t m0 x6 h2 yc5 ff1 fs0 fc1 sc0 ls2 ws4">
              descriptions of Your activity, communicat
              <span className="_ _2"></span>e with You and view Your profile.
            </div>
            <div className="t m0 x2 h2 yc6 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff6 ls2">
                  With Your consent
                  <span className="ff1">
                    : We may disclose Your person<span className="_ _2"></span>
                    al information for any other purpose wit
                    <span className="_ _2"></span>h
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 yc7 ff1 fs0 fc1 sc0 ls2 ws4">
              Your consent.
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf7" className="pf w0 h0" data-page-no="7">
          <div className="pc pc7 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">7</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y63 ff3 fs4 fc0 sc0 ls2 ws4">
              Retention of<span className="_ _0"></span> Your
              <span className="_ _0"></span>
              Personal Data<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y64 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company will retain Your <span className="_ _2"></span>
              Personal Data only for as long as is necessary for the purposes
              <span className="_ _2"></span>set
            </div>
            <div className="t m0 x2 h2 y65 ff1 fs0 fc1 sc0 ls2 ws4">
              out in this Privacy Policy. We will retain and use Yo
              <span className="_ _2"></span>ur Personal Data to the extent n
              <span className="_ _2"></span>ecessar
              <span className="_ _0"></span>y to
            </div>
            <div className="t m0 x2 h2 y66 ff1 fs0 fc1 sc0 ls2 ws4">
              comply with our legal obligations (for example, i
              <span className="_ _2"></span>f we are required to retain your
              data to co<span className="_ _2"></span>mply
            </div>
            <div className="t m0 x2 h2 y67 ff1 fs0 fc1 sc0 ls2 ws4">
              with applicable laws), resolve disputes, and enf
              <span className="_ _2"></span>orce our legal agreements and p
              <span className="_ _2"></span>olicies.
            </div>
            <div className="t m0 x2 h2 yc8 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company will also retain Usage Data
              <span className="_ _2"></span>for internal analysis purposes.
              Usage Data i<span className="_ _2"></span>s generally
            </div>
            <div className="t m0 x2 h2 yc9 ff1 fs0 fc1 sc0 ls2 ws4">
              retained for a shorter period of time,
              <span className="_ _2"></span>except when this data is used to
              strengt
              <span className="_ _2"></span>hen the security or to
            </div>
            <div className="t m0 x2 h2 yca ff1 fs0 fc1 sc0 ls2 ws4">
              improve the functionality of Our Service, or
              <span className="_ _2"></span>We are legally obligated to retain
              this data for l<span className="_ _2"></span>onger
            </div>
            <div className="t m0 x2 h2 ycb ff1 fs0 fc1 sc0 ls2 ws4">
              time periods.
            </div>
            <div className="t m0 x2 h6 ycc ff3 fs4 fc0 sc0 ls2 ws4">
              Transfer of Yo<span className="_ _0"></span>ur Pers
              <span className="_ _0"></span>onal Dat
              <span className="_ _0"></span>a
            </div>
            <div className="t m0 x2 h2 ycd ff1 fs0 fc1 sc0 ls2 ws4">
              Your information, including Personal Data,
              <span className="_ _2"></span>
              is processed at the Company&apos;s operating offices and in
            </div>
            <div className="t m0 x2 h2 yce ff1 fs0 fc1 sc0 ls2 ws4">
              any other places where the <span className="_ _2"></span>parties
              involved in the processing are located. It me
              <span className="_ _2"></span>ans that this
            </div>
            <div className="t m0 x2 h2 ycf ff1 fs0 fc1 sc0 ls2 ws4">
              information may be transferred to — and
              <span className="_ _2"></span>maintained on — computers located
              outside o<span className="_ _2"></span>f Your
            </div>
            <div className="t m0 x2 h2 yd0 ff1 fs0 fc1 sc0 ls2 ws4">
              state, province, country or <span className="_ _2"></span>other
              governmental jurisdiction where the data protection law
              <span className="_ _2"></span>s may
            </div>
            <div className="t m0 x2 h2 yd1 ff1 fs0 fc1 sc0 ls2 ws4">
              differ than those from Your jurisdiction.
              <span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 yd2 ff1 fs0 fc1 sc0 ls2 ws4">
              Your consent to this Privacy Poli<span className="_ _2"></span>cy
              follo<span className="_ _0"></span>wed by{" "}
              <span className="_ _2"></span>
              Your submission of such information represent
              <span className="_ _2"></span>s
            </div>
            <div className="t m0 x2 h2 yd3 ff1 fs0 fc1 sc0 ls2 ws4">
              Your agreement to that transfer.
            </div>
            <div className="t m0 x2 h2 yd4 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company will take all<span className="_ _2"></span> steps
              reasonably necessary to ensure t<span className="_ _2"></span>hat
              Your data is treated securely
            </div>
            <div className="t m0 x2 h2 yd5 ff1 fs0 fc1 sc0 ls2 ws4">
              and in accordance with this Privacy Pol
              <span className="_ _2"></span>
              icy
              <span className="_ _0"></span>and no tra
              <span className="_ _2"></span>
              nsfer of Your Personal Data will take place to
            </div>
            <div className="t m0 x2 h2 yd6 ff1 fs0 fc1 sc0 ls2 ws4">
              an organization or a country <span className="_ _2"></span>unless
              there are adequate controls in place inclu
              <span className="_ _2"></span>ding the security of
            </div>
            <div className="t m0 x2 h2 yd7 ff1 fs0 fc1 sc0 ls2 ws4">
              Your data and other personal infor<span className="_ _2"></span>
              mation.
            </div>
            <div className="t m0 x2 h6 yd8 ff3 fs4 fc0 sc0 ls2 ws4">
              Data Retention &amp;<span className="_ _0"></span> Tran
              <span className="_ _0"></span>sfer Afte
              <span className="_ _0"></span>r Contract Te
              <span className="_ _0"></span>rmination
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 yd9 ff1 fs0 fc1 sc0 ls2 ws4">
              WE WILL NOT TRANSFER<span className="_ _2"></span>, MIGRATE, OR
              DISCLOSE End User&apos;<span className="_ _2"></span>s personal
              data to any other service
            </div>
            <div className="t m0 x2 h2 yda ff1 fs0 fc1 sc0 ls2 ws4">
              provider without the explicit, documented
              <span className="_ _2"></span>consent of each affected End User.
            </div>
            <div className="t m0 x2 h2 y3d ff6 fs0 fc1 sc0 ls2 ws4">
              1. Client Church/Charity Co<span className="_ _2"></span>ntr
              <span className="_ _0"></span>act Termi
              <span className="_ _2"></span>
              nation
            </div>
            <div className="t m0 x2 h2 y3e ff1 fs0 fc1 sc0 ls2 ws4">
              When a Client Church/Charity ends <span className="_ _2"></span>
              its
              <span className="_ _0"></span>
              agreement <span className="_ _2"></span>with ChurchPlan®:
            </div>
            <div className="t m0 x2 h2 ydb ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls4 ws4">
                <span className="ff1 fs0 ls2">
                  All End User personal data remains
                  <span className="_ _2"></span>under the control of the
                  individual End U<span className="_ _2"></span>sers (data
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 ydc ff1 fs0 fc1 sc0 ls2 ws4">
              subjects).
            </div>
            <div className="t m0 x2 h2 ydd ff6 fs0 fc1 sc0 ls2 ws4">
              2. End User Rights Post-Termination
            </div>
            <div className="t m0 x2 h2 yde ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls4 ws4">
                <span className="ff6 fs0 ls2">
                  Access &amp; Deletion<span className="ff1">: </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 ydf ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls6 ws4">
                <span className="ff1 fs0 ls2">
                  Users may access their data anyt<span className="_ _2"></span>
                  ime in the app’s &quot;Profile&quot; section.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 ye0 ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls6 ws4">
                <span className="ff1 fs0 ls2">
                  Users can delete their data perman
                  <span className="_ _2"></span>
                  ently via the app’s &quot;Delete Account&quot; feat
                  <span className="_ _2"></span>ure, or by
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 ye1 ff1 fs0 fc1 sc0 ls2 ws4">
              visiting: https://web.churchplan.or<span className="_ _2"></span>
              g/delete-account
            </div>
            <div className="t m0 x2 h2 ye2 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls4 ws4">
                <span className="ff6 fs0 ls2">
                  Consent-Based Transfers<span className="ff1">: </span>
                </span>
              </span>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf8" className="pf w0 h0" data-page-no="8">
          <div className="pc pc8 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">8</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y20 ff1 fs0 fc1 sc0 ls2 ws4">
              If a Client Church/Charity organizes a mi
              <span className="_ _2"></span>gration to a new provider, every{" "}
              <span className="_ _2"></span>End User must provide
            </div>
            <div className="t m0 x2 h2 y21 ff9 fs0 fc1 sc0 ls2 ws1">
              explicit
              <span className="ff1 ws4">
                consent through a verified method (
                <span className="_ _2"></span>
                such as email confirmation or in-app autho
                <span className="_ _2"></span>rization) to
              </span>
            </div>
            <div className="t m0 x2 h2 ya6 ff1 fs0 fc1 sc0 ls2 ws4">
              proceed with the transfer. Without this individual o
              <span className="_ _2"></span>pt-in, ChurchPlan will not{" "}
              <span className="_ _2"></span>be involved in the
            </div>
            <div className="t m0 x2 h2 ye3 ff1 fs0 fc1 sc0 ls2 ws4">
              migration process.
            </div>
            <div className="t m0 x2 h6 ye4 ff3 fs4 fc0 sc0 ls2 ws4">
              Sale of Pers<span className="_ _0"></span>onal Informa
              <span className="_ _0"></span>tion
            </div>
            <div className="t m0 x2 h2 yc8 ff1 fs0 fc1 sc0 ls2 ws4">
              We do NOT<span className="ff6"> </span>and will NOT sell your
              personal inf<span className="_ _2"></span>ormation.
            </div>
            <div className="t m0 x2 h6 ye5 ff3 fs4 fc0 sc0 ls2 ws4">
              Disclosur<span className="_ _0"></span>e of Your Pe
              <span className="_ _0"></span>rsonal Da
              <span className="_ _0"></span>ta
            </div>
            <div className="t m0 x2 h7 ye6 ff6 fs0 fc1 sc0 ls2 ws4">
              Business Transactions<span className="ff3 fc0"> </span>
            </div>
            <div className="t m0 x2 h2 ye7 ff1 fs0 fc1 sc0 ls2 ws4">
              If the Company is involve<span className="_ _2"></span>d in a
              merger, acquisition or asset sale, Your Pers
              <span className="_ _2"></span>onal Data may be
            </div>
            <div className="t m0 x2 h2 ye8 ff1 fs0 fc1 sc0 ls2 ws4">
              transferred. We will provide noti<span className="_ _2"></span>ce
              before Your Personal Data is transferred{" "}
              <span className="_ _2"></span>and becomes subject
            </div>
            <div className="t m0 x2 h2 ye9 ff1 fs0 fc1 sc0 ls2 ws4">
              to a different Privacy Policy.
            </div>
            <div className="t m0 x2 h2 y2e ff6 fs0 fc1 sc0 ls2 ws4">
              Law enforcement
            </div>
            <div className="t m0 x2 h2 yea ff1 fs0 fc1 sc0 ls2 ws4">
              Under certain circumstances,<span className="_ _2"></span> the
              Company may be req<span className="_ _2"></span>uired to disclose
              Your Personal Data if
            </div>
            <div className="t m0 x2 h2 yeb ff1 fs0 fc1 sc0 ls2 ws4">
              required to do so by law or in re<span className="_ _2"></span>
              sponse to valid requests by public authorities (e.g. a court or a
            </div>
            <div className="t m0 x2 h2 yec ff1 fs0 fc1 sc0 ls2 ws4">
              government agency).
            </div>
            <div className="t m0 x2 h2 yed ff6 fs0 fc1 sc0 ls2 ws4">
              Other legal requiremen<span className="_ _2"></span>ts
            </div>
            <div className="t m0 x2 h2 yee ff1 fs0 fc1 sc0 ls2 ws4">
              The Company may disclose Your Personal Data
              <span className="_ _2"></span>in the good faith belief that such
              action
              <span className="_ _2"></span>is necessary
            </div>
            <div className="t m0 x2 h2 yef ff1 fs0 fc1 sc0 ls2 ws4">to:</div>
            <div className="t m0 x2 h2 yf0 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Comply with a legal obligation<span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 yf1 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Protect and defend the ri<span className="_ _2"></span>ghts or
                  property of the Company
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 yf2 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Prevent or investigate possible wron
                  <span className="_ _2"></span>
                  gdoing in connection with the Service
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 yf3 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Protect the personal safety <span className="_ _2"></span>of
                  Users of the Service or the public
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 yf4 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Protect against legal liabil<span className="_ _2"></span>ity
                </span>
              </span>
            </div>
            <div className="t m0 x2 h6 yf5 ff3 fs4 fc0 sc0 ls2 ws4">
              Security<span className="_ _0"></span> of Your Pers
              <span className="_ _0"></span>onal D<span className="_ _0"></span>
              ata
            </div>
            <div className="t m0 x2 h2 yf6 ff1 fs0 fc1 sc0 ls2 ws4">
              The security of Your Personal Data is import
              <span className="_ _2"></span>ant to Us, but remember t
              <span className="_ _2"></span>hat no method of
            </div>
            <div className="t m0 x2 h2 yf7 ff1 fs0 fc1 sc0 ls2 ws4">
              transmission over the Internet, or me
              <span className="_ _2"></span>
              thod of electronic storage is 100% secure. While We str
              <span className="_ _2"></span>ive to
            </div>
            <div className="t m0 x2 h2 yf8 ff1 fs0 fc1 sc0 ls2 ws4">
              use commercially acceptable mean<span className="_ _2"></span>s to
              protect Your Personal Data, We cannot guarantee it
              <span className="_ _2"></span>s
            </div>
            <div className="t m0 x2 h2 yf9 ff1 fs0 fc1 sc0 ls2 ws4">
              absolute security.
            </div>
            <div className="t m0 x2 h3 yfa ff2 fs1 fc2 sc0 ls2 ws4">
              D<span className="_ _0"></span>eta<span className="_ _0"></span>i
              <span className="_ _0"></span>l<span className="_ _0"></span>ed
              <span className="_ _1"></span> I<span className="_ _0"></span>nfor
              <span className="_ _0"></span>m<span className="_ _0"></span>at
              <span className="_ _1"></span>i<span className="_ _0"></span>on
              <span className="_ _0"></span>
              <span className="_ _0"></span>on<span className="_ _1"></span>
              <span className="_ _0"></span>th<span className="_ _1"></span>e
              <span className="_ _0"></span>
              <span className="_ _0"></span>Proc<span className="_ _1"></span>e
              <span className="_ _0"></span>s<span className="_ _0"></span>s
              <span className="_ _0"></span>i<span className="_ _0"></span>ng
              <span className="_ _1"></span> o<span className="_ _0"></span>f
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h3 yfb ff2 fs1 fc2 sc0 ls2 ws4">
              Y<span className="_ _3"></span>ou<span className="_ _1"></span>r
              <span className="_ _0"></span>
              Pe<span className="_ _0"></span>rso<span className="_ _0"></span>
              na
              <span className="_ _0"></span>l<span className="_ _0"></span>{" "}
              <span className="_ _0"></span>D<span className="_ _1"></span>ata
            </div>
            <div className="t m0 x2 h2 yfc ff1 fs0 fc1 sc0 ls2 ws4">
              The Service Providers We use <span className="_ _2"></span>may
              have access to Your Personal Dat<span className="_ _2"></span>a.
              These third-party vendors
            </div>
            <div className="t m0 x2 h2 yfd ff1 fs0 fc1 sc0 ls2 ws4">
              collect, store, use, process and tran
              <span className="_ _2"></span>
              sfer<span className="_ _0"></span> information
              <span className="_ _2"></span>about Your activity on Our Servi
              <span className="_ _2"></span>ce in
            </div>
            <div className="t m0 x2 h2 yfe ff1 fs0 fc1 sc0 ls2 ws4">
              accordance with their Privacy Policies.
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf9" className="pf w0 h0" data-page-no="9">
          <div className="pc pc9 w0 h0">
            <div className="t m0 x1 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">9</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y63 ff3 fs4 fc0 sc0 ls2 ws4">
              Analytics<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y64 ff1 fs0 fc1 sc0 ls2 ws4">
              We may use third-party Service providers to mon
              <span className="_ _2"></span>itor and analyze the use of our
              Servic
              <span className="_ _2"></span>e.
            </div>
            <div className="t m0 x5 h2 yff ff6 fs0 fc1 sc0 ls2 ws4">
              Google Analytics<span className="ff1"> </span>
            </div>
            <div className="t m0 x5 h2 y87 ff1 fs0 fc1 sc0 ls2 ws4">
              Google Analytics is a web analyt<span className="_ _2"></span>ics
              service offered by Google that tracks and reports
            </div>
            <div className="t m0 x5 h2 y88 ff1 fs0 fc1 sc0 ls2 ws4">
              website traffic. Google uses the data c
              <span className="_ _2"></span>
              ollected to track and monitor the use of our Service.
            </div>
            <div className="t m0 x5 h2 yc8 ff1 fs0 fc1 sc0 ls2 ws4">
              This data is shared with other Google servi
              <span className="_ _2"></span>ces. Google may use the collected
              data to
            </div>
            <div className="t m0 x5 h2 yc9 ff1 fs0 fc1 sc0 ls2 ws4">
              contextualize and person<span className="_ _2"></span>alize the
              ads of its own advertising network.
            </div>
            <div className="t m0 x5 h2 yca ff1 fs0 fc1 sc0 ls2 ws4">
              You may opt-out of certain <span className="_ _2"></span>Googl
              <span className="_ _0"></span>e Analyt
              <span className="_ _2"></span>ics features through your mobile
              device settings,
            </div>
            <div className="t m0 x5 h2 ycb ff1 fs0 fc1 sc0 ls2 ws4">
              such as your device advertising <span className="_ _2"></span>
              settings or by following the instructions provided by
              <span className="_ _2"></span>Google
            </div>
            <div className="t m0 x5 h2 y100 ff1 fs0 fc1 sc0 ls2 ws4">
              in their Privacy Policy: https://policies.google.com/privacy
            </div>
            <div className="t m0 x5 h2 y101 ff1 fs0 fc1 sc0 ls2 ws4">
              For more information on the privacy practices o
              <span className="_ _2"></span>f Google, please visit the Google
              Privacy &amp;
            </div>
            <div className="t m0 x5 h2 y102 ff1 fs0 fc1 sc0 ls2 ws4">
              Terms web page: https://policies.google.co
              <span className="_ _2"></span>m/privacy
            </div>
            <div className="t m0 x5 h2 y103 ff6 fs0 fc1 sc0 ls2 ws1">
              Firebase<span className="ff1 ws4"> </span>
            </div>
            <div className="t m0 x5 h2 y104 ff1 fs0 fc1 sc0 ls2 ws4">
              Firebase is an analytics service provided by
              <span className="_ _2"></span>Google Inc.
            </div>
            <div className="t m0 x5 h2 y105 ff1 fs0 fc1 sc0 ls2 ws4">
              You may opt-out of certain <span className="_ _2"></span>Firebase
              features through your mobile device settings, such as
            </div>
            <div className="t m0 x5 h2 y106 ff1 fs0 fc1 sc0 ls2 ws4">
              your device advertising settings or by
              <span className="_ _2"></span>following the instructions provided
              by
              <span className="_ _2"></span>Google in their
            </div>
            <div className="t m0 x5 h2 y107 ff1 fs0 fc1 sc0 ls2 ws4">
              Privacy Policy: https://policies.google.com/pr
              <span className="_ _2"></span>ivacy
            </div>
            <div className="t m0 x5 h2 y108 ff1 fs0 fc1 sc0 ls2 ws4">
              We also encourage you to <span className="_ _2"></span>review the
              Google&apos;s policy for safeguarding your data:
            </div>
            <div className="t m0 x5 h2 y109 ff1 fs0 fc1 sc0 ls2 ws4">
              https://support.google.com/analyt<span className="_ _2"></span>
              ics/ans
              <span className="_ _0"></span>wer/60<span className="_ _2"></span>
              04245
            </div>
            <div className="t m0 x5 h2 y10a ff1 fs0 fc1 sc0 ls2 ws4">
              For more information on what typ<span className="_ _2"></span>e of
              information Firebase collects, please visit the How
            </div>
            <div className="t m0 x5 h2 y10b ff1 fs0 fc1 sc0 ls2 ws4">
              Google uses data when you use our partner
              <span className="_ _2"></span>s&apos; sites or apps webpage:
            </div>
            <div className="t m0 x5 h2 y10c ff1 fs0 fc1 sc0 ls2 ws4">
              https://policies.google.co<span className="_ _2"></span>
              m/technologies/partner-sites
            </div>
            <div className="t m0 x2 h6 y10d ff3 fs4 fc0 sc0 ls2 ws4">
              Email Marke<span className="_ _0"></span>ting
            </div>
            <div className="t m0 x2 h2 y10e ff1 fs0 fc1 sc0 ls2 ws4">
              We may use Your Persona<span className="_ _2"></span>l Data to
              contact You with newsletters, marketing o
              <span className="_ _2"></span>r promotional
            </div>
            <div className="t m0 x2 h2 y10f ff1 fs0 fc1 sc0 ls2 ws4">
              materials and other information <span className="_ _2"></span>that
              may be of interest to You. You <span className="_ _2"></span>may
              opt-out of receiving any, or
            </div>
            <div className="t m0 x2 h2 y110 ff1 fs0 fc1 sc0 ls2 ws4">
              all, of these communication<span className="_ _2"></span>s from Us
              by following the unsubscribe link or ins
              <span className="_ _2"></span>
              tructions provided in
            </div>
            <div className="t m0 x2 h2 y111 ff1 fs0 fc1 sc0 ls2 ws4">
              any email We send or by cont<span className="_ _2"></span>acting
              Us.
            </div>
            <div className="t m0 x2 h6 y112 ff3 fs4 fc0 sc0 ls2 ws4">
              Payments<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y113 ff1 fs0 fc1 sc0 ls2 ws4">
              We may provide paid products and/or
              <span className="_ _2"></span>services within the Service. In that
              case, we may use t<span className="_ _2"></span>hird-
            </div>
            <div className="t m0 x2 h2 y114 ff1 fs0 fc1 sc0 ls2 ws4">
              party services for payment<span className="_ _2"></span>{" "}
              processing (e.g. payment processors).
            </div>
            <div className="t m0 x2 h2 y115 ff1 fs0 fc1 sc0 ls2 ws4">
              We will not store or collect <span className="_ _2"></span>Your
              <span className="_ _0"></span>
              pay<span className="_ _2"></span>ment card details. That
              information is pro<span className="_ _2"></span>vided directly to
              Our
            </div>
            <div className="t m0 x2 h2 y116 ff1 fs0 fc1 sc0 ls2 ws4">
              third-party payment processors whose use of
              <span className="_ _2"></span>Your personal information is
              governed b<span className="_ _2"></span>y their
            </div>
            <div className="t m0 x2 h2 y117 ff1 fs0 fc1 sc0 ls2 ws4">
              Privacy Policy. These payment processors adhere t
              <span className="_ _2"></span>o the standards set by PCI-DSS as
              managed by
            </div>
            <div className="t m0 x2 h2 y118 ff1 fs0 fc1 sc0 ls2 ws4">
              the PCI Security Standard<span className="_ _2"></span>s Council,
              which is a joint effort of brands like Visa,
              <span className="_ _2"></span>
              Mastercard, American
            </div>
            <div className="t m0 x2 h2 y119 ff1 fs0 fc1 sc0 ls2 ws4">
              Express and Discover. PCI-DSS requirement
              <span className="_ _2"></span>s help ensure the secure handling of
              payment
            </div>
            <div className="t m0 x2 h2 y11a ff1 fs0 fc1 sc0 ls2 ws4">
              information.
            </div>
            <div className="t m0 x2 h6 y11b ff3 fs4 fc0 sc0 ls2 ws4">
              Usage, Perfo<span className="_ _0"></span>rmance a
              <span className="_ _0"></span>nd Miscellan
              <span className="_ _0"></span>
              eous
            </div>
            <div className="t m0 x2 h2 y11c ff1 fs0 fc1 sc0 ls2 ws4">
              We may use third-party Service Providers to prov
              <span className="_ _2"></span>ide better improvement of our
              Service.
              <span className="_ _2"></span>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pfa" className="pf w0 h0" data-page-no="a">
          <div className="pc pca w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">10</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x5 h2 y20 ff6 fs0 fc1 sc0 ls2 ws4">
              Google Places<span className="ff1"> </span>
            </div>
            <div className="t m0 x5 h2 y21 ff1 fs0 fc1 sc0 ls2 ws4">
              Google Places is a service that returns informat
              <span className="_ _2"></span>ion about places using HTTP
              requests. It
              <span className="_ _2"></span>is
            </div>
            <div className="t m0 x5 h2 ya6 ff1 fs0 fc1 sc0 ls2 ws4">
              operated by Google
            </div>
            <div className="t m0 x5 h2 ye3 ff1 fs0 fc1 sc0 ls2 ws4">
              Google Places service may colle<span className="_ _2"></span>ct
              information from You and from Your Device for se
              <span className="_ _2"></span>curity
            </div>
            <div className="t m0 x5 h2 y11d ff1 fs0 fc1 sc0 ls2 ws4">
              purposes.
            </div>
            <div className="t m0 x5 h2 y11e ff1 fs0 fc1 sc0 ls2 ws4">
              The information gathered b<span className="_ _2"></span>y Google
              Places is held in accordance with the Privacy Policy of
            </div>
            <div className="t m0 x5 h2 y11f ff1 fs0 fc1 sc0 ls2 ws4">
              Google: https://www.google.co<span className="_ _2"></span>
              m/intl/en/policies/privacy/
            </div>
            <div className="t m0 x2 h3 y120 ff2 fs1 fc2 sc0 ls2 ws4">
              Ch<span className="_ _1"></span>i<span className="_ _0"></span>l
              <span className="_ _0"></span>d<span className="_ _0"></span>re
              <span className="_ _0"></span>n<span className="_ _0"></span>
              &apos;s
              <span className="_ _0"></span> P<span className="_ _0"></span>r
              <span className="_ _0"></span>i<span className="_ _0"></span>va
              <span className="_ _0"></span>c<span className="_ _0"></span>y
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y50 ff1 fs0 fc1 sc0 ls2 ws4">
              The Service may contain content appropri
              <span className="_ _2"></span>
              ate for children under the age of 13.
              <span className="_ _2"></span> As a parent, you
            </div>
            <div className="t m0 x2 h2 y2c ff1 fs0 fc1 sc0 ls2 ws4">
              should know that through the Service children unde
              <span className="_ _2"></span>r the age of 13 may partici
              <span className="_ _2"></span>pate in activities that
            </div>
            <div className="t m0 x2 h2 y2d ff1 fs0 fc1 sc0 ls2 ws4">
              involve the collection or use of person
              <span className="_ _2"></span>
              al information. We use reasonable efforts to ensure that
            </div>
            <div className="t m0 x2 h2 y2e ff1 fs0 fc1 sc0 ls2 ws4">
              before we collect any personal information from a c
              <span className="_ _2"></span>hild, the child&apos;s parent
              receives notice of and
            </div>
            <div className="t m0 x2 h2 y2f ff1 fs0 fc1 sc0 ls2 ws4">
              consents to our personal information pra
              <span className="_ _2"></span>
              ctices.
            </div>
            <div className="t m0 x2 h2 y121 ff1 fs0 fc1 sc0 ls2 ws4">
              We also may limit how We collect, use, an
              <span className="_ _2"></span>d store some of the information of
              Users between 13 an<span className="_ _2"></span>d
            </div>
            <div className="t m0 x2 h2 y122 ff1 fs0 fc1 sc0 ls2 ws4">
              18 years old. In some cases, this mean
              <span className="_ _2"></span>s We will be unable to provide
              certain functionality o<span className="_ _2"></span>f the
            </div>
            <div className="t m0 x2 h2 y123 ff1 fs0 fc1 sc0 ls2 ws4">
              Service to these Users. If We need to re
              <span className="_ _2"></span>
              ly on consent as a legal basis for proc
              <span className="_ _2"></span>
              essing Your
            </div>
            <div className="t m0 x2 h2 y124 ff1 fs0 fc1 sc0 ls2 ws4">
              information and Your count<span className="_ _2"></span>ry
              requires co
              <span className="_ _0"></span>nsent from a parent,
              <span className="_ _2"></span>We may require Your parent&apos;s
            </div>
            <div className="t m0 x2 h2 yef ff1 fs0 fc1 sc0 ls2 ws4">
              consent before We collect a<span className="_ _2"></span>nd use
              that information.
            </div>
            <div className="t m0 x2 h2 y125 ff1 fs0 fc1 sc0 ls2 ws4">
              We may ask a User to verify its date of birth be
              <span className="_ _2"></span>fore collecting any personal
              information fro<span className="_ _2"></span>m them.
            </div>
            <div className="t m0 x2 h2 y126 ff1 fs0 fc1 sc0 ls2 ws4">
              If the User is under the age of 13, the Service
              <span className="_ _2"></span>
              will be either blocked or redirected to a parental
            </div>
            <div className="t m0 x2 h2 y127 ff1 fs0 fc1 sc0 ls2 ws4">
              consent process.
            </div>
            <div className="t m0 x2 h6 y128 ff3 fs4 fc0 sc0 ls2 ws4">
              Information<span className="_ _0"></span> Collecte
              <span className="_ _0"></span>d from Child
              <span className="_ _0"></span>
              ren Unde<span className="_ _0"></span>r the Age of 13
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y129 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company may collect an<span className="_ _2"></span>d stor
              <span className="_ _0"></span>e persisten
              <span className="_ _2"></span>t identifiers such as cookies or IP
              addresses from
            </div>
            <div className="t m0 x2 h2 y12a ff1 fs0 fc1 sc0 ls2 ws4">
              Children without parental<span className="_ _2"></span> consent
              for the purpose of supporting the internal
              <span className="_ _2"></span>operation of the
            </div>
            <div className="t m0 x2 h2 y3d ff1 fs0 fc1 sc0 ls2 ws4">
              Service.
            </div>
            <div className="t m0 x2 h2 y12b ff1 fs0 fc1 sc0 ls2 ws4">
              We may collect and store other personal
              <span className="_ _2"></span>information about children if this
              information is sub<span className="_ _2"></span>mitted
            </div>
            <div className="t m0 x2 h2 y12c ff1 fs0 fc1 sc0 ls2 ws4">
              by a child with prior parent consent or by the pare
              <span className="_ _2"></span>nt or guardian of the child.
            </div>
            <div className="t m0 x2 h2 y7f ff1 fs0 fc1 sc0 ls2 ws4">
              The Company may collect an<span className="_ _2"></span>d stor
              <span className="_ _0"></span>e the followin
              <span className="_ _2"></span>g types of personal information
              about a child w<span className="_ _2"></span>hen
            </div>
            <div className="t m0 x2 h2 ydd ff1 fs0 fc1 sc0 ls2 ws4">
              submitted by a child with prior parental con
              <span className="_ _2"></span>sent or by the parent or guardian of
              the child:
            </div>
            <div className="t m0 x2 h2 y12d ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">First and Last name </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y12e ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Date of birth </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y12f ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Gender </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y130 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Grade level </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y131 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Email address </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y132 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Telephone number </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y133 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Picture </span>
              </span>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pfb" className="pf w0 h0" data-page-no="b">
          <div className="pc pcb w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">11</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y49 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Parent&apos;s or guardian&apos;s name &amp; contact
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y134 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Health Insurance </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y135 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Doctor’s name &amp; contact </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y136 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Allergies </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y137 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Special Accommodation </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y138 ff1 fs0 fc1 sc0 ls2 ws4">
              For further details on the infor<span className="_ _2"></span>
              mation We might collect, You can refer to the &quot;Types of Data
            </div>
            <div className="t m0 x2 h2 y139 ff1 fs0 fc1 sc0 ls2 ws4">
              Collected&quot; section of this Privacy Policy. We fol
              <span className="_ _2"></span>low our standard Privacy Policy for
              the d<span className="_ _2"></span>isc
              <span className="_ _0"></span>losure of
            </div>
            <div className="t m0 x2 h2 y13a ff1 fs0 fc1 sc0 ls2 ws4">
              personal information collected from an
              <span className="_ _2"></span>d about children.
            </div>
            <div className="t m0 x2 h6 y13b ff3 fs4 fc0 sc0 ls2 ws4">
              Parental Ac<span className="_ _0"></span>cess
            </div>
            <div className="t m0 x2 h2 y13c ff1 fs0 fc1 sc0 ls2 ws4">
              A parent who has already given the Company
              <span className="_ _2"></span>permission to collect and use his
              child personal
            </div>
            <div className="t m0 x2 h2 y13d ff1 fs0 fc1 sc0 ls2 ws4">
              information can, at any time:<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y13e ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Review, correct or delete the child
                  <span className="_ _2"></span>
                  &apos;s personal information
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y13f ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Discontinue further collection or use of t
                  <span className="_ _2"></span>he child&apos;s perso
                  <span className="_ _0"></span>nal information
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y140 ff1 fs0 fc1 sc0 ls2 ws4">
              To make such a request, You can wr<span className="_ _2"></span>
              ite to Us using the contact information{" "}
              <span className="_ _2"></span>
              provided in this Privacy
            </div>
            <div className="t m0 x2 h2 y141 ff1 fs0 fc1 sc0 ls2 ws4">
              Policy.
            </div>
            <div className="t m0 x2 h3 y124 ff2 fs1 fc2 sc0 ls2 ws4">
              L<span className="_ _0"></span>i<span className="_ _0"></span>n
              <span className="_ _0"></span>ks <span className="_ _1"></span>to
              <span className="_ _0"></span> O<span className="_ _1"></span>th
              <span className="_ _0"></span>e<span className="_ _0"></span>r
              <span className="_ _0"></span>W<span className="_ _2"></span>e
              <span className="_ _0"></span>bs<span className="_ _1"></span>i
              <span className="_ _0"></span>t<span className="_ _2"></span>e
              <span className="_ _0"></span>s<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y142 ff1 fs0 fc1 sc0 ls2 ws4">
              Our Service may contain links to ot<span className="_ _2"></span>
              her websites that are not operated by Us. If You click on a third
              <span className="_ _2"></span>-
            </div>
            <div className="t m0 x2 h2 y143 ff1 fs0 fc1 sc0 ls2 ws4">
              party link, You will be directed to t
              <span className="_ _2"></span>hat third party&apos;s site.
              ChurchPlan is not responsible for any
            </div>
            <div className="t m0 x2 h2 y144 ff1 fs0 fc1 sc0 ls2 ws4">
              personal information shared on third-party web
              <span className="_ _2"></span>sites and cannot guarantee i
              <span className="_ _2"></span>ts secu
              <span className="_ _0"></span>rity.
              <span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y145 ff1 fs0 fc1 sc0 ls2 ws4">
              We strongly advise You to review the Privacy Pol
              <span className="_ _2"></span>icy of every site You visit. We have
              no control over
            </div>
            <div className="t m0 x2 h2 y146 ff1 fs0 fc1 sc0 ls2 ws4">
              and assume no responsibility for the conten
              <span className="_ _2"></span>t, privacy policies or practices of
              any
              <span className="_ _2"></span>third-<span className="_ _0"></span>
              party sites or
            </div>
            <div className="t m0 x2 h2 y147 ff1 fs0 fc1 sc0 ls2 ws4">
              services.
            </div>
            <div className="t m0 x2 h2 y148 ff1 fs0 fc1 sc0 ls2 ws4">
              <span className="_ _4"> </span>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pfc" className="pf w0 h0" data-page-no="c">
          <div className="pc pcc w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">12</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h8 y134 ff3 fs8 fc2 sc0 ls2 ws4">
              I<span className="_ _0"></span>nter<span className="_ _1"></span>n
              <span className="_ _0"></span>ati<span className="_ _1"></span>o
              <span className="_ _0"></span>n<span className="_ _0"></span>a
              <span className="_ _0"></span>l <span className="_ _1"></span>P
              <span className="_ _0"></span>r<span className="_ _1"></span>iva
              <span className="_ _0"></span>c<span className="_ _1"></span>y
              <span className="_ _0"></span> L<span className="_ _0"></span>a
              <span className="_ _0"></span>ws<span className="_ _0"></span>{" "}
              <span className="_ _0"></span>C<span className="_ _0"></span>o
              <span className="_ _0"></span>m<span className="_ _1"></span>pl
              <span className="_ _1"></span>ia<span className="_ _1"></span>n
              <span className="_ _0"></span>c<span className="_ _0"></span>e
              <span className="_ _0"></span> <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h3 y149 ff2 fs1 fc2 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h3 y14a ff2 fs1 fc2 sc0 ls2 ws4">
              Un<span className="_ _1"></span>i<span className="_ _0"></span>te
              <span className="_ _0"></span>d <span className="_ _0"></span>S
              <span className="_ _0"></span>ta<span className="_ _0"></span>tes
              <span className="_ _0"></span> P<span className="_ _1"></span>r
              <span className="_ _0"></span>i<span className="_ _0"></span>va
              <span className="_ _0"></span>c<span className="_ _0"></span>y L
              <span className="_ _1"></span>aws<span className="_ _0"></span>
              <span className="_ _0"></span>C<span className="_ _0"></span>o
              <span className="_ _0"></span>m<span className="_ _0"></span>p
              <span className="_ _0"></span>l<span className="_ _0"></span>i
              <span className="_ _0"></span>a<span className="_ _0"></span>nc
              <span className="_ _1"></span>e
            </div>
            <div className="t m0 x2 h2 y14b ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y14c ff1 fs0 fc1 sc0 ls2 ws4">
              The Company, <span className="ff6 ws1">ChurchPlan</span>, adheres
              to appl<span className="_ _2"></span>icable U.S. federal and state
              privacy laws, including but
            </div>
            <div className="t m0 x2 h2 y14d ff1 fs0 fc1 sc0 ls2 ws4">
              not limited to:
            </div>
            <div className="t m0 x2 h2 y14e ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  California Consumer Privacy Act (CCPA)
                  <span className="_ _2"></span>
                  &amp; California Privacy Rights Act (CPRA)
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y14f ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Virginia Consumer Data Protect<span className="_ _2"></span>
                  ion Act (VCDPA)
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y8e ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">Colorado Privacy Act (CPA) </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y150 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Connecticut Data Privacy Act (CTDPA)
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y151 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Utah Consumer Privacy Act (UCPA)<span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y152 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Other state laws (as they come into effe
                  <span className="_ _2"></span>ct)
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y153 ff1 fs0 fc1 sc0 ls2 ws4">
              This section outlines the rights of U.S. residents and
              <span className="_ _2"></span>our compliance obligations.
            </div>
            <div className="t m0 x2 h6 y154 ff3 fs4 fc0 sc0 ls2 ws4">
              1. Categori<span className="_ _0"></span>es of Perso
              <span className="_ _0"></span>nal Data C
              <span className="_ _0"></span>
              ollected
            </div>
            <div className="t m0 x2 h2 yef ff1 fs0 fc1 sc0 ls2 ws4">
              We collect the following categ<span className="_ _2"></span>ories
              of personal data (as defined by appli
              <span className="_ _2"></span>cable laws):
            </div>
            <div className="t m0 x2 h2 y155 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Identifiers (e.g., name, email, IP address)
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y156 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Commercial information (e.g., purchase history)
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y157 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Internet/network activity (e.g., browsing b
                  <span className="_ _2"></span>ehavior)
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y158 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Geolocation data (if enabl<span className="_ _2"></span>ed by
                  the user)
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y159 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Inferences (e.g., user preferences)
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y15a ff1 fs0 fc1 sc0 ls2 ws4">
              For a full list, see the &quot;Types of Data Co
              <span className="_ _2"></span>llected&quot; section of this
              Privacy Policy.
            </div>
            <div className="t m0 x2 h6 y15b ff3 fs4 fc0 sc0 ls2 ws4">
              2. Consume<span className="_ _0"></span>r Rights Un
              <span className="_ _0"></span>der U.S. S
              <span className="_ _0"></span>tate Laws
            </div>
            <div className="t m0 x2 h2 y114 ff1 fs0 fc1 sc0 ls2 ws4">
              Depending on your state of res<span className="_ _2"></span>
              idence, you may have the following rights:
            </div>
            <div className="t m0 x2 h2 y15c ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y15d ff6 fs0 fc1 sc0 ls2 ws4">
              a) Right to Know &amp; Acces<span className="_ _2"></span>s
            </div>
            <div className="t m0 x2 h2 y15e ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Users may access &amp; edit their data a
                  <span className="_ _2"></span>nytime in the app’s
                  &quot;Profile&quot; section.
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y15f ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Request confirmation of whether we p
                  <span className="_ _2"></span>
                  rocess your personal data.
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y160 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Obtain a copy of your data in a p
                  <span className="_ _2"></span>
                  ortable format (up to twice p<span className="_ _2"></span>er
                  year).
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y161 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y162 ff6 fs0 fc1 sc0 ls2 ws4">
              b) Right to Delete<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y163 ff1 fs0 fc1 sc0 ls2 ws4"></div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pfd" className="pf w0 h0" data-page-no="d">
          <div className="pc pcd w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">13</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y49 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Request deletion of person<span className="_ _2"></span>al
                  data, subject to legal exceptions (e.g., fraud prevention,
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y4a ff1 fs0 fc1 sc0 ls2 ws4">
              compliance).
            </div>
            <div className="t m0 x2 h2 y164 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Users can delete their data perman
                  <span className="_ _2"></span>
                  ently via the app’s &quot;Delete Account&quot; feat
                  <span className="_ _2"></span>ure, or by visiting:
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y4b ff1 fs0 fc1 sc0 ls2 ws4">
              https://web.churchplan.org/delete-ac<span className="_ _2"></span>
              count
            </div>
            <div className="t m0 x2 h2 y165 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y166 ff6 fs0 fc1 sc0 ls2 ws4">
              c) Right to Correct<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y167 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Users may access &amp; edit their data a
                  <span className="_ _2"></span>nytime in the app’s
                  &quot;Profile&quot; section.
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y168 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <span className="ff1 ls2">
                  Request correction of inaccurate personal data (und
                  <span className="_ _2"></span>er CPRA, VCDPA, CPA, and CTDPA).
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y8c ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y2b ff6 fs0 fc1 sc0 ls2 ws4">
              d) Right to Opt Out of:
            </div>
            <div className="t m0 x2 h2 y169 ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls7 ws4">
                <span className="ff1 ls2">
                  Sales of personal data (a<span className="_ _2"></span>s defi
                  <span className="_ _0"></span>ned by CCPA/CPRA){" "}
                  <span className="_ _2"></span>– We do not sell and will not Yo
                  <span className="_ _2"></span>ur personal
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y16a ff1 fs0 fc1 sc0 ls2 ws4">
              data, No Opt Out action is required<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y16b ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls7 ws4">
                <span className="ff1 ls2">
                  Targeted advertising (under VCDPA, CPA, C
                  <span className="_ _2"></span>TDPA, UCPA).
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y16c ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls7 ws4">
                <span className="ff1 ls2">
                  Profiling for automated d<span className="_ _2"></span>
                  ecision-making (under some state law
                  <span className="_ _2"></span>
                  s).
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y16d ff6 fs0 fc1 sc0 ls2 ws4">
              e) Right to Non-Discriminatio<span className="_ _2"></span>n
            </div>
            <div className="t m0 x2 h2 y16e ff1 fs0 fc1 sc0 ls2 ws4">
              We will not deny services, charge d<span className="_ _2"></span>
              iff
              <span className="_ _0"></span>erent prices, o
              <span className="_ _2"></span>r provide a lower quality of service
              for
            </div>
            <div className="t m0 x2 h2 y16f ff1 fs0 fc1 sc0 ls2 ws4">
              exercising privacy rights.
            </div>
            <div className="t m0 x2 h2 y170 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y171 ff6 fs0 fc1 sc0 ls2 ws4">
              f) Right to Appeal (Unde<span className="_ _2"></span>r VCDPA,
              CPA, CTDPA)
            </div>
            <div className="t m0 x2 h2 y172 ff1 fs0 fc1 sc0 ls2 ws4">
              If we deny a request, you may appeal with
              <span className="_ _2"></span>in a reasonable period.
            </div>
            <div className="t m0 x2 h2 y173 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y174 ff3 fs4 fc0 sc0 ls2 ws4">
              3. How to Ex<span className="_ _0"></span>ercise You
              <span className="_ _0"></span>r Rights
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y175 ff1 fs0 fc1 sc0 ls2 ws4">
              Submit a verifiable request via:
            </div>
            <div className="t m0 x2 h2 y176 ff1 fs0 fc1 sc0 ls2 ws4">
              Email: privacyofficer@churchplan.org<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y177 ff1 fs0 fc1 sc0 ls2 ws4">
              We may require authentication to prevent fr
              <span className="_ _2"></span>aud. Authorized agents must provide
              proo
              <span className="_ _2"></span>f of
            </div>
            <div className="t m0 x2 h2 y178 ff1 fs0 fc1 sc0 ls2 ws4">
              authorization.
            </div>
            <div className="t m0 x2 h2 y179 ff1 fs0 fc1 sc0 ls2 ws4">
              We aim to respond within <span className="_ _2"></span>45 days
              (may extend once by an additional 45 days
              <span className="_ _2"></span> with notice).
            </div>
            <div className="t m0 x2 h2 y17a ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y17b ff3 fs4 fc0 sc0 ls2 ws4">
              4. &quot;Do Not Sell<span className="_ _0"></span> or Shar
              <span className="_ _0"></span>e My P<span className="_ _0"></span>
              ersonal Inform<span className="_ _0"></span>ation&quot;
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y17c ff1 fs0 fc1 sc0 ls2 ws4">
              Under CCPA/CPRA, Californ<span className="_ _2"></span>ia
              residents may opt out of:
            </div>
            <div className="t m0 x2 h2 y17d ff1 fs0 fc1 sc0 ls2 ws4">
              Sales of data (if applicable).
            </div>
            <div className="t m0 x2 h2 y17e ff1 fs0 fc1 sc0 ls2 ws4">
              Sharing for cross-context behavioral advert
              <span className="_ _2"></span>ising.
            </div>
            <div className="t m0 x2 h2 y17f ff1 fs0 fc1 sc0 ls2 ws4">
              To opt out:
            </div>
            <div className="t m0 x2 h2 y180 ff1 fs0 fc1 sc0 ls2 ws4">
              We do not sell your perso<span className="_ _2"></span>nal
              information, so no opt-out action is need
              <span className="_ _2"></span>ed.
            </div>
            <div className="t m0 x2 h6 y181 ff3 fs4 fc0 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y182 ff3 fs4 fc0 sc0 ls2 ws4">
              5. Sensitiv<span className="_ _0"></span>e Personal I
              <span className="_ _0"></span>nformation
              <span className="_ _0"></span> (Unde<span className="_ _0"></span>
              r CPRA)
            </div>
            <div className="t m0 x2 h2 y183 ff1 fs0 fc1 sc0 ls2 ws4">
              We do not use or disclose sensitive personal inform
              <span className="_ _2"></span>ation (e.g., racial origin,
              biometrics) for
            </div>
            <div className="t m0 x2 h2 y184 ff1 fs0 fc1 sc0 ls2 ws4">
              purposes beyond what is <span className="_ _2"></span>necessary
              under law unless we obtain explicit con
              <span className="_ _2"></span>sent.
            </div>
            <div className="t m0 x2 h2 y185 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y186 ff3 fs4 fc0 sc0 ls2 ws4">
              6. Data Re<span className="_ _0"></span>tention &amp;
              <span className="_ _0"></span>Security
              <span className="_ _0"></span>
              <span className="ff1 fs0 fc1"> </span>
            </div>
            <div className="t m0 x2 h2 y187 ff1 fs0 fc1 sc0 ls2 ws4">
              We retain personal data only <span className="_ _2"></span>as long
              <span className="_ _0"></span>
              as necessary for <span className="_ _2"></span>business or legal
              purposes.
            </div>
            <div className="t m0 x2 h2 y188 ff1 fs0 fc1 sc0 ls2 ws4">
              We implement reasonable security measures, inclu
              <span className="_ _2"></span>ding encryption and access controls.
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pfe" className="pf w0 h0" data-page-no="e">
          <div className="pc pce w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">14</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y189 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y18a ff3 fs4 fc0 sc0 ls2 ws4">
              7. Children’<span className="_ _0"></span>s Privacy
              <span className="_ _0"></span>
              (COPPA Comp<span className="_ _0"></span>liance)
            </div>
            <div className="t m0 x2 h2 y18b ff1 fs0 fc1 sc0 ls2 ws4">
              We do not knowingly collect data fr<span className="_ _2"></span>
              om children under 13 without parental consent.
              <span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y86 ff1 fs0 fc1 sc0 ls2 ws4">
              Parents may review, delete, or restri
              <span className="_ _2"></span>ct data collection by contacting us.
            </div>
            <div className="t m0 x2 h2 ya7 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y18c ff3 fs4 fc0 sc0 ls2 ws4">
              8. Updates<span className="_ _0"></span> &amp; Conta
              <span className="_ _0"></span>ct
            </div>
            <div className="t m0 x2 h2 y18d ff1 fs0 fc1 sc0 ls2 ws4">
              We will update this section as new<span className="_ _2"></span>{" "}
              state laws take effect. For questions:
            </div>
            <div className="t m0 x2 h2 y18e ff1 fs0 fc1 sc0 ls2 ws4">
              Email: privacyofficer@churchplan.org<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y18f ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h3 y6d ff2 fs1 fc2 sc0 ls2 ws4">
              P<span className="_ _0"></span>I<span className="_ _0"></span>P
              <span className="_ _0"></span>EDA<span className="_ _1"></span> C
              <span className="_ _0"></span>om<span className="_ _0"></span>p
              <span className="_ _1"></span>l<span className="_ _0"></span>i
              <span className="_ _0"></span>a<span className="_ _0"></span>nc
              <span className="_ _0"></span>e<span className="_ _1"></span>
              (C<span className="_ _1"></span>a<span className="_ _0"></span>na
              <span className="_ _1"></span>da<span className="_ _1"></span>)
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y190 ff6 fs0 fc1 sc0 ls2 ws4">
              Personal Information Pro<span className="_ _2"></span>tection and
              Electronic Documents Act (PIPEDA)<span className="ff1"> </span>
            </div>
            <div className="t m0 x2 h2 y191 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company, <span className="ff6 ws1">ChurchPlan</span>, is
              committed to c<span className="_ _2"></span>omplying with the
              <span className="ff6">
                P<span className="_ _0"></span>ersonal Info
                <span className="_ _2"></span>rmation Protection
              </span>
            </div>
            <div className="t m0 x2 h2 y192 ff6 fs0 fc1 sc0 ls2 ws4">
              and Electronic Documents Ac<span className="_ _2"></span>t
              (PIPEDA)
              <span className="_ _0"></span>
              <span className="ff1">
                of Canada. This se<span className="_ _2"></span>ction outlines
                our practices regarding
              </span>
            </div>
            <div className="t m0 x2 h2 y193 ff1 fs0 fc1 sc0 ls2 ws4">
              the collection, use, and disclo<span className="_ _2"></span>su
              <span className="_ _0"></span>re of personal in
              <span className="_ _2"></span>formation in accordance with
              PIPEDA&apos;s principl<span className="_ _2"></span>es.
            </div>
            <div className="t m0 x2 h6 y194 ff3 fs4 fc0 sc0 ls2 ws4">
              1. Accoun<span className="_ _0"></span>tability
            </div>
            <div className="t m0 x2 h2 y195 ff1 fs0 fc1 sc0 ls2 ws4">
              We are responsible for the personal infor
              <span className="_ _2"></span>mation under our control and have
              <span className="_ _2"></span>designated a Privacy
            </div>
            <div className="t m0 x2 h2 y196 ff1 fs0 fc1 sc0 ls2 ws4">
              Officer to ensure compliance with PIPEDA.
              <span className="_ _2"></span>The Privacy Officer can be contacted
              at:
            </div>
            <div className="t m0 x6 h2 y77 ff4 fs7 fc1 sc0 ls2 ws5">
              <span className="ff5 ls4 ws4"> </span>
              <span className="ff6 fs0 ws1">
                Email:
                <span className="ff1 ws4">
                  <span className="fc5 ws1">privacyofficer@churchplan.org</span>
                </span>
              </span>
            </div>
            <div className="t m0 x2 h6 y197 ff3 fs4 fc0 sc0 ls2 ws4">
              2. Identifyin<span className="_ _0"></span>g Purpose
              <span className="_ _0"></span>s
            </div>
            <div className="t m0 x2 h2 y198 ff1 fs0 fc1 sc0 ls2 ws4">
              We collect personal information for the foll
              <span className="_ _2"></span>owing purposes:
            </div>
            <div className="t m0 x6 h2 y199 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  To provide and maintain t<span className="_ _2"></span>he
                  Service.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y19a ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  To manage user accounts and authenticat
                  <span className="_ _2"></span>e identities.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y19b ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  To communicate with users regard<span className="_ _2"></span>
                  ing updates, security alerts, and support.
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y19c ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  To improve and customize the Service.
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y19d ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  To comply with legal and regulatory requ
                  <span className="_ _2"></span>irements.
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y19e ff1 fs0 fc1 sc0 ls2 ws4">
              The purposes for collection are co<span className="_ _2"></span>
              mmunicated at or before the time of collection.
            </div>
            <div className="t m0 x2 h6 y80 ff3 fs4 fc0 sc0 ls2 ws4">
              3. Consent<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y19f ff1 fs0 fc1 sc0 ls2 ws4">
              We obtain <span className="ff6">meaningful consent</span> before
              collecting, using, or disclosing per<span className="_ _2"></span>
              sonal information, except
            </div>
            <div className="t m0 x2 h2 y1a0 ff1 fs0 fc1 sc0 ls2 ws4">
              where otherwise permitted or required b
              <span className="_ _2"></span>y law. Consent may be express (e.g
              <span className="_ _2"></span>., through a checkbox)
            </div>
            <div className="t m0 x2 h2 y1a1 ff1 fs0 fc1 sc0 ls2 ws4">
              or implied (e.g., by using the Service after being
              <span className="_ _2"></span>informed of this Privacy Policy).
            </div>
            <div className="t m0 x2 h2 y1a2 ff1 fs0 fc1 sc0 ls2 ws4">
              Users may <span className="ff6">withdraw consent</span> at any
              time, subject t<span className="_ _2"></span>o legal or
              contractual restrictions, by contactin
              <span className="_ _2"></span>g
            </div>
            <div className="t m0 x2 h2 y1a3 ff1 fs0 fc1 sc0 ls2 ws4">
              us. However, withdrawing consent <span className="_ _2"></span>may
              limit access to certain features of the{" "}
              <span className="_ _2"></span>
              Service.
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pff" className="pf w0 h0" data-page-no="f">
          <div className="pc pcf w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">15</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y63 ff3 fs4 fc0 sc0 ls2 ws4">
              4. Limitin<span className="_ _0"></span>g Collection
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y1a4 ff1 fs0 fc1 sc0 ls2 ws4">
              We collect only the personal infor<span className="_ _2"></span>
              mation nec<span className="_ _0"></span>essary
              <span className="_ _2"></span> for the identified purposes. The
              types of data
            </div>
            <div className="t m0 x2 h2 yff ff1 fs0 fc1 sc0 ls2 ws4">
              collected are outlined in the
              <span className="ff6">
                &quot;Types of Data Coll<span className="_ _2"></span>
                ected&quot;
                <span className="_ _0"></span>
                <span className="ff1"> section of this Privacy Policy. </span>
              </span>
            </div>
            <div className="t m0 x2 h6 y1a5 ff3 fs4 fc0 sc0 ls2 ws4">
              5. Limitin<span className="_ _0"></span>g Use, Disclo
              <span className="_ _0"></span>sure, and R
              <span className="_ _0"></span>
              etention
            </div>
            <div className="t m0 x2 h2 y18e ff1 fs0 fc1 sc0 ls2 ws4">
              Personal information is used or disclosed
              <span className="_ _2"></span>only for the purposes for which it
              was collected, unless
            </div>
            <div className="t m0 x2 h2 y1a6 ff1 fs0 fc1 sc0 ls2 ws4">
              the user provides additional consent or as r
              <span className="_ _2"></span>equired by law.
            </div>
            <div className="t m0 x2 h2 y4e ff1 fs0 fc1 sc0 ls2 ws4">
              We retain personal information on<span className="_ _2"></span>ly
              as long as necessary to fulfill the ident
              <span className="_ _2"></span>
              ified purposes or as
            </div>
            <div className="t m0 x2 h2 y1a7 ff1 fs0 fc1 sc0 ls2 ws4">
              required by law. After this period, the information is securely
              <span className="_ _2"></span>destroyed or anonymized.
            </div>
            <div className="t m0 x2 h6 y1a8 ff3 fs4 fc0 sc0 ls2 ws4">
              6. Accuracy<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y1a9 ff1 fs0 fc1 sc0 ls2 ws4">
              ChurchPlan® relies on users to provide and
              <span className="_ _2"></span>maintain their own personal info
              <span className="_ _2"></span>rmation within our
            </div>
            <div className="t m0 x2 h2 y1aa ff1 fs0 fc1 sc0 ls2 ws4">
              system. As such, all user-entered data i
              <span className="_ _2"></span>s presumed to be accurate and
              current at the ti
              <span className="_ _2"></span>me of<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y1ab ff1 fs0 fc1 sc0 ls2 ws4">
              submission.
            </div>
            <div className="t m0 x2 h2 y1ac ff1 fs0 fc1 sc0 ls2 ws4">
              For manually processed i<span className="_ _2"></span>nform
              <span className="_ _0"></span>ation, we{" "}
              <span className="_ _2"></span>make reasonable efforts to verify
              its accuracy,
            </div>
            <div className="t m0 x2 h2 y1ad ff1 fs0 fc1 sc0 ls2 ws4">
              completeness, and timeliness for it<span className="_ _2"></span>s
              intended use. Should users identify any discrepanci
              <span className="_ _2"></span>es in their
            </div>
            <div className="t m0 x2 h2 y1ae ff1 fs0 fc1 sc0 ls2 ws4">
              personal data, they may submit correct
              <span className="_ _2"></span>
              ion requests by contacting our suppor
              <span className="_ _2"></span>t team.
            </div>
            <div className="t m0 x2 h6 y1af ff3 fs4 fc0 sc0 ls2 ws4">
              7. Safegu<span className="_ _0"></span>ards
            </div>
            <div className="t m0 x2 h2 y1b0 ff1 fs0 fc1 sc0 ls2 ws4">
              We implement
              <span className="ff6">
                physical, organizatio<span className="_ _2"></span>nal, and
                technical safeguards
                <span className="ff1">
                  to<span className="_ _0"></span> protect p
                  <span className="_ _2"></span>ersonal
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y1b1 ff1 fs0 fc1 sc0 ls2 ws4">
              information against loss, theft, unauthorized a
              <span className="_ _2"></span>ccess, disclosure, or modification.
              These
              <span className="_ _2"></span>measures
            </div>
            <div className="t m0 x2 h2 y1b2 ff1 fs0 fc1 sc0 ls2 ws4">
              include:
            </div>
            <div className="t m0 x6 h2 y1b3 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Encryption of sensitive data.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1b4 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Restricted access to person<span className="_ _2"></span>al
                  information on a need-to-know basis.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1b5 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Regular security audits and trainin
                  <span className="_ _2"></span>g for employees.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1b6 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y1b7 ff3 fs4 fc0 sc0 ls2 ws4">
              8. Opennes<span className="_ _0"></span>s
            </div>
            <div className="t m0 x2 h2 y1b8 ff1 fs0 fc1 sc0 ls2 ws4">
              This Privacy Policy, along with any additiona
              <span className="_ _2"></span>l documentation, is made readily
              available to u<span className="_ _2"></span>sers to
            </div>
            <div className="t m0 x2 h2 y1b9 ff1 fs0 fc1 sc0 ls2 ws4">
              explain our practices regarding person
              <span className="_ _2"></span>al information.
            </div>
            <div className="t m0 x2 h6 y1ba ff3 fs4 fc0 sc0 ls2 ws4">
              9. Individual<span className="_ _0"></span> Access
            </div>
            <div className="t m0 x5 h2 y1bb ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls6 ws4">
                <span className="ff1 fs0 ls2">
                  Users may access &amp; edit their data anyt
                  <span className="_ _2"></span>ime in the app’s
                  &quot;Profile&quot; section.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 ya3 ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls6 ws4">
                <span className="ff1 fs0 ls2">
                  Users can delete their data perman
                  <span className="_ _2"></span>
                  ently via the app’s &quot;Delete Account&quot; feat
                  <span className="_ _2"></span>ure, or by
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y1bc ff1 fs0 fc1 sc0 ls2 ws4">
              visiting:
              <span className="fc5 ws1">
                https://web.churchplan.or<span className="_ _2"></span>
                g/delete-account<span className="fc1 ws4"> </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y1bd ff1 fs0 fc1 sc0 ls2 ws4">
              Upon request, users have the right to:
            </div>
            <div className="t m0 x6 h2 y1be ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Access their personal information hel
                  <span className="_ _2"></span>d by us.
                </span>
              </span>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf10" className="pf w0 h0" data-page-no="10">
          <div className="pc pc10 w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">16</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x6 h2 y20 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Challenge the accuracy or completenes
                  <span className="_ _2"></span>s of the information and request
                  corrections.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y21 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Be informed of any third parties to whom the
                  <span className="_ _2"></span>ir information has been
                  disclosed.
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 ya6 ff1 fs0 fc1 sc0 ls2 ws4">
              Requests for access or corrections must be ma
              <span className="_ _2"></span>de i<span className="_ _0"></span>n
              w<span className="_ _2"></span>riting to the Privacy Officer and
              may require
            </div>
            <div className="t m0 x2 h2 ye3 ff1 fs0 fc1 sc0 ls2 ws4">
              verification of identity.
            </div>
            <div className="t m0 x2 h6 y1bf ff3 fs4 fc0 sc0 ls2 ws4">
              10. Challengin<span className="_ _0"></span>g Compl
              <span className="_ _0"></span>iance
            </div>
            <div className="t m0 x2 h2 y89 ff1 fs0 fc1 sc0 ls2 ws4">
              Users may address any concerns, complaints,
              <span className="_ _2"></span>or questions about our compliance w
              <span className="_ _2"></span>ith PIPEDA to
            </div>
            <div className="t m0 x2 h2 y8a ff1 fs0 fc1 sc0 ls2 ws4">
              the Privacy Officer. We wi<span className="_ _2"></span>ll
              investigate and respond to all inquiries promptly.
              <span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h3 yad ff2 fs1 fc2 sc0 ls2 ws4">
              G<span className="_ _0"></span>e<span className="_ _0"></span>n
              <span className="_ _0"></span>eral<span className="_ _0"></span>{" "}
              <span className="_ _1"></span>Data<span className="_ _0"></span>
              <span className="_ _0"></span>Prote<span className="_ _1"></span>
              ct
              <span className="_ _1"></span>i<span className="_ _0"></span>on
              <span className="_ _0"></span>
              <span className="_ _1"></span>R<span className="_ _2"></span>e
              <span className="_ _0"></span>g<span className="_ _0"></span>u
              <span className="_ _0"></span>l<span className="_ _0"></span>ati
              <span className="_ _0"></span>o<span className="_ _1"></span>n
              <span className="_ _0"></span>(<span className="_ _1"></span>G
              <span className="_ _0"></span>D<span className="_ _0"></span>PR
              <span className="_ _1"></span>)
            </div>
            <div className="t m0 x2 h3 ye9 ff2 fs1 fc2 sc0 ls2 ws4">
              Co<span className="_ _0"></span>m<span className="_ _1"></span>pl
              <span className="_ _1"></span>i<span className="_ _0"></span>a
              <span className="_ _0"></span>nc<span className="_ _0"></span>e{" "}
              <span className="_ _1"></span>(E<span className="_ _1"></span>U
              <span className="_ _1"></span>&amp;<span className="_ _0"></span>
              <span className="_ _0"></span>U<span className="_ _0"></span>K
              <span className="_ _0"></span>)
            </div>
            <div className="t m0 x2 h2 y1c0 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company, <span className="ff6 ws1">ChurchPlan</span>, is
              committed to c<span className="_ _2"></span>omplying with the
              <span className="ff6">
                Gen<span className="_ _0"></span>eral Data Protection
              </span>
            </div>
            <div className="t m0 x2 h2 yd1 ff6 fs0 fc1 sc0 ls2 ws4">
              Regulation (GDPR) (EU)<span className="_ _2"></span> 2016/679
              <span className="_ _0"></span>
              <span className="ff1">
                when processing the pers<span className="_ _2"></span>onal data
                of individuals in the
              </span>
            </div>
            <div className="t m0 x2 h2 y1c1 ff1 fs0 fc1 sc0 ls2 ws4">
              European Union (EU) and<span className="_ _2"></span> European
              Economic Area (EEA). This se<span className="_ _2"></span>ction
              outlines the rights of data
            </div>
            <div className="t m0 x2 h2 y1c2 ff1 fs0 fc1 sc0 ls2 ws4">
              subjects and our obligation<span className="_ _2"></span>s under
              GDPR.
            </div>
            <div className="t m0 x8 h2 y1c3 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y171 ff3 fs4 fc0 sc0 ls2 ws4">
              1. Lawful<span className="_ _0"></span> Basis for Pro
              <span className="_ _0"></span>cessing
              <span className="_ _0"></span> Personal D
              <span className="_ _0"></span>ata
            </div>
            <div className="t m0 x2 h2 y1c4 ff1 fs0 fc1 sc0 ls2 ws4">
              We process personal data only w<span className="_ _2"></span>hen
              we have a <span className="_ _0"></span>
              <span className="ff6">
                valid legal ba<span className="_ _2"></span>sis
                <span className="ff1">
                  , inc<span className="_ _0"></span>luding:
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1c5 ff4 fs7 fc1 sc0 ls2 ws5">
              <span className="ff5 ls8 ws4"> </span>
              <span className="ff6 fs0 ws1">
                Consent
                <span className="ff1 ws4">
                  – The data subject has given clear, inf
                  <span className="_ _2"></span>ormed, and revocable consent.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1c6 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Contractual necessity
                  <span className="ff1">
                    – Processing is necessary to<span className="_ _2"></span>{" "}
                    fulfill a contract (e.g., providing the
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1c7 ff1 fs0 fc1 sc0 ls2 ws4">
              Service).
            </div>
            <div className="t m0 x6 h2 y1c8 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Legal obligation
                  <span className="ff1">
                    – Processing is required to c<span className="_ _2"></span>
                    omply with EU or member state law.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1c9 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Legitimate interests
                  <span className="ff1">
                    – Processing is necessary for our le
                    <span className="_ _2"></span>gitimate business interests,
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1ca ff1 fs0 fc1 sc0 ls2 ws4">
              provided they do not override individual r
              <span className="_ _2"></span>ights.
            </div>
            <div className="t m0 x5 h2 y1cb ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y1cc ff3 fs4 fc0 sc0 ls2 ws4">
              2. Rights of D<span className="_ _0"></span>ata Sub
              <span className="_ _0"></span>jects Unde
              <span className="_ _0"></span>r GDPR<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y19e ff1 fs0 fc1 sc0 ls2 ws4">
              Individuals in the EU/EEA have the following r
              <span className="_ _2"></span>ights regarding their personal data:
            </div>
            <div className="t m0 x2 h2 y1cd ff6 fs0 fc1 sc0 ls2 ws4">
              a) Right to Access (Article 15 GDPR)<span className="ff1"> </span>
            </div>
            <div className="t m0 x2 h2 y1ce ff1 fs0 fc1 sc0 ls2 ws4">
              You may request a copy of your personal data
              <span className="_ _2"></span>, including:
            </div>
            <div className="t m0 x6 h2 y1cf ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">The purposes of processing.</span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1d0 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">Categories of data held. </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1d1 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">Recipients of the data. </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1d2 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">Retention periods. </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1d3 ff1 fs0 fc1 sc0 ls2 ws4"></div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf11" className="pf w0 h0" data-page-no="11">
          <div className="pc pc11 w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">17</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y20 ff6 fs0 fc1 sc0 ls2 ws4">
              b) Right to Rectification (Article 16 G
              <span className="_ _2"></span>
              DPR)
            </div>
            <div className="t m0 x5 h2 y1d4 ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls9 ws4">
                <span className="ff1 fs0 ls2">
                  Users may access &amp; edit their data anyt
                  <span className="_ _2"></span>ime in the app’s
                  &quot;Profile&quot; section.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1d5 ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls9 ws4">
                <span className="ff1 fs0 ls2">
                  You may request corrections to inaccurate
                  <span className="_ _2"></span>or incomplete data.
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y1d6 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y1d7 ff6 fs0 fc1 sc0 ls2 ws4">
              c) Right to Erasure (&quot;Right to Be For
              <span className="_ _2"></span>gotten&quot;) (Article 17{" "}
              <span className="_ _2"></span>G<span className="_ _0"></span>DPR)
            </div>
            <div className="t m0 x5 h2 y1d8 ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls6 ws4">
                <span className="ff1 fs0 ls2">
                  Users can delete their data perman
                  <span className="_ _2"></span>
                  ently via the app’s &quot;Delete Account&quot; feat
                  <span className="_ _2"></span>ure, or by
                </span>
              </span>
            </div>
            <div className="t m0 x3 h2 y1d9 ff1 fs0 fc1 sc0 ls2 ws4">
              visiting:
              <span className="fc5 ws1">
                https://web.churchplan.or<span className="_ _2"></span>
                g/delete-account<span className="fc1 ws4"> </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1da ff8 fs7 fc1 sc0 ls5">
              o
              <span className="ff5 ls6 ws4">
                <span className="ff1 fs0 ls2">
                  You may request deletion of your data w
                  <span className="_ _2"></span>hen:
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y1db ffa fs7 fc1 sc0 lsa">
              
              <span className="ff5 lsb ws4">
                <span className="ff1 fs0 ls2">
                  It is no longer necessary for the original purp
                  <span className="_ _2"></span>ose.
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y1dc ffa fs7 fc1 sc0 lsa">
              
              <span className="ff5 lsb ws4">
                <span className="ff1 fs0 ls2">
                  You withdraw consent (and n<span className="_ _2"></span>o
                  other
                  <span className="_ _0"></span> legal basis ap
                  <span className="_ _2"></span>plies).
                </span>
              </span>
            </div>
            <div className="t m0 x4 h2 y1dd ffa fs7 fc1 sc0 lsa">
              
              <span className="ff5 lsb ws4">
                <span className="ff1 fs0 ls2">
                  It was unlawfully processed.
                </span>
              </span>
            </div>
            <div className="t m0 x9 h2 y1de ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 ycf ff9 fs0 fc1 sc0 ls2 ws4">
              Exceptions apply (e.g., legal com<span className="_ _2"></span>
              pliance, public interest, or defense of legal claims).
              <span className="ff1"></span>
            </div>
            <div className="t m0 x2 h2 y1df ff6 fs0 fc1 sc0 ls2 ws4">
              d) Right to Restriction o<span className="_ _2"></span>f
              Processing (Article 18 GDPR)<span className="ff1"> </span>
            </div>
            <div className="t m0 x2 h2 yec ff1 fs0 fc1 sc0 ls2 ws4">
              You may request tempora<span className="_ _2"></span>ry
              restriction of processing if:
            </div>
            <div className="t m0 x6 h2 y123 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  You contest the data’s accuracy.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 yee ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Processing is unlawful, but you oppose era
                  <span className="_ _2"></span>sure.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 yef ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  We no longer need the data, b<span className="_ _2"></span>ut
                  you require it for legal claims.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1e0 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y1e1 ff6 fs0 fc1 sc0 ls2 ws4">
              e) Right to Data Portability (Article
              <span className="_ _2"></span>20<span className="_ _0"></span>
              <span className="_ _2"></span>GDP<span className="_ _0"></span>R)
              <span className="ff1"></span>
            </div>
            <div className="t m0 x2 h2 y127 ff1 fs0 fc1 sc0 ls2 ws4">
              You may request a structured, mac<span className="_ _2"></span>
              hine-readable copy of your data for trans
              <span className="_ _2"></span>fer to another service
            </div>
            <div className="t m0 x2 h2 y1e2 ff1 fs0 fc1 sc0 ls2 ws4">
              provider (where processing is based on consent or
              <span className="_ _2"></span>contractual necessity).
              <span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y1e3 ff6 fs0 fc1 sc0 ls2 ws4">
              f) Right to Object (Article 21 G<span className="_ _2"></span>DPR)
              <span className="ff1"></span>
            </div>
            <div className="t m0 x2 h2 y1e4 ff1 fs0 fc1 sc0 ls2 ws4">
              You may object to processing based on:
              <span className="_ _2"></span>
            </div>
            <div className="t m0 x6 h2 y1e5 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Legitimate interests
                  <span className="ff1">
                    (unless we demonstrate com<span className="_ _2"></span>
                    pelling grounds).
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1e6 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Direct marketing
                  <span className="ff1">
                    (absolute right to opt out).<span className="_ _2"></span>{" "}
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1e7 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y1e8 ff6 fs0 fc1 sc0 ls2 ws4">
              g) Rights Related to Aut<span className="_ _2"></span>omated
              Decision-Making (Article 2<span className="_ _2"></span>2 GDPR)
              <span className="_ _0"></span>
              <span className="ff1"> </span>
            </div>
            <div className="t m0 x2 h2 y1e9 ff1 fs0 fc1 sc0 ls2 ws4">
              You have the right not to be subj<span className="_ _2"></span>ect
              to decisions based <span className="_ _0"></span>
              <span className="ff6">
                solely on automated p<span className="_ _2"></span>rocessing
                <span className="_ _0"></span>
                <span className="ff1"> (e.g., </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y1ea ff1 fs0 fc1 sc0 ls2 ws4">
              profiling) that significantly affect you, unless:
            </div>
            <div className="t m0 x6 h2 y1eb ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">Necessary for a contract. </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1ec ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Authorized by EU/member <span className="_ _2"></span>state
                  law.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1ed ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">Based on explicit consent. </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1ee ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y1ef ff3 fs4 fc0 sc0 ls2 ws4">
              3. Data Pro<span className="_ _0"></span>tection Me
              <span className="_ _0"></span>asures
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf12" className="pf w0 h0" data-page-no="12">
          <div className="pc pc12 w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">18</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y20 ff1 fs0 fc1 sc0 ls2 ws4">
              We implement
              <span className="ff6">
                technical and organizational
                <span className="_ _2"></span>measures
                <span className="ff1">
                  to ensure GDPR compliance, including:
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1f0 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Data minimization
                  <span className="ff1">
                    – Collecting only <span className="_ _2"></span>necessary
                    data.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1f1 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Encryption &amp; pseudonymizatio<span className="_ _2"></span>
                  n<span className="_ _0"></span>
                  <span className="ff1">
                    – Protecting data in t<span className="_ _2"></span>ransit
                    and at rest.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 ya7 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Access controls
                  <span className="ff1">
                    – Limiting employee access to per
                    <span className="_ _2"></span>
                    sonal data.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 ya8 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Data Protection Impact <span className="_ _2"></span>
                  Assessments (DPIAs)<span className="_ _0"></span>
                  <span className="ff1">
                    – Conducted for high-r<span className="_ _2"></span>isk
                    processing.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 ya9 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y1f2 ff3 fs4 fc0 sc0 ls2 ws4">
              4. Interna<span className="_ _0"></span>tional Dat
              <span className="_ _0"></span>a Transfe
              <span className="_ _0"></span>rs
            </div>
            <div className="t m0 x2 h2 y1da ff1 fs0 fc1 sc0 ls2 ws4">
              If personal data is transferred outside the EU/EEA
              <span className="_ _2"></span>, we ensure safeguards such as:
            </div>
            <div className="t m0 x6 h2 y8c ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Adequacy decisions
                  <span className="ff1">
                    (e.g., transfers to Canada unde
                    <span className="_ _2"></span>r the EU adequacy ruling).
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y8d ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Standard Contractual Cl<span className="_ _2"></span>auses
                  (SCCs)
                  <span className="_ _0"></span>
                  <span className="ff1">
                    with third part<span className="_ _2"></span>ies.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1f3 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Binding Corporate Rule<span className="_ _2"></span>s (BCRs)
                  <span className="_ _0"></span>
                  <span className="ff1">
                    for intra-group t<span className="_ _2"></span>ransf
                    <span className="_ _0"></span>ers.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1f4 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y1f5 ff3 fs4 fc0 sc0 ls2 ws4">
              5. Data B<span className="_ _0"></span>reach Notifi
              <span className="_ _0"></span>cation
            </div>
            <div className="t m0 x2 h2 yeb ff1 fs0 fc1 sc0 ls2 ws4">
              In the event of a<span className="ff6">personal data breach</span>{" "}
              likely to result in a ri<span className="_ _2"></span>sk to rights
              and freedoms, we will:
            </div>
            <div className="t m0 x6 h2 y122 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Notify the
                  <span className="ff6">
                    relevant EU supervisory authori
                    <span className="_ _2"></span>ty
                    <span className="_ _0"></span>
                    <span className="ff1"> within </span>72 hours
                    <span className="ff1">.</span>
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 yed ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Inform affected individuals
                  <span className="ff6">without undue delay</span> if the breach
                  poses a hig<span className="_ _2"></span>h risk.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 yee ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y1f6 ff3 fs4 fc0 sc0 ls2 ws4">
              6. Data Pro<span className="_ _0"></span>tection Offi
              <span className="_ _0"></span>cer (DPO)
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y1f7 ff1 fs0 fc1 sc0 ls2 ws4">
              While not legally required for our operations, we
              <span className="_ _2"></span>have appointed a{" "}
              <span className="_ _0"></span>
              <span className="ff6">Privacy Officer</span> to oversee
            </div>
            <div className="t m0 x2 h2 y1f8 ff1 fs0 fc1 sc0 ls2 ws4">
              GDPR compliance. Contact<span className="_ _2"></span>:
            </div>
            <div className="t m0 x6 h2 y1f9 ff4 fs7 fc1 sc0 ls2 ws5">
              <span className="ff5 ls4 ws4"> </span>
              <span className="ff6 fs0 ws1">
                Email:
                <span className="ff1 ws4">
                  privacyofficer@churchplan.org<span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x2 h6 y1fa ff3 fs4 fc0 sc0 ls2 ws4">
              7. Complain<span className="_ _0"></span>ts
            </div>
            <div className="t m0 x2 h2 y1fb ff1 fs0 fc1 sc0 ls2 ws4">
              If you believe we have violated GDPR t
              <span className="_ _2"></span>
              erms, you may a<span className="_ _2"></span>ddress your concern
              to our Privacy Officer.
            </div>
            <div className="t m0 x2 h2 y1fc ff1 fs0 fc1 sc0 ls2 ws4">
              We will investigate and respond to all
              <span className="_ _2"></span>inquiries promptly.
            </div>
            <div className="t m0 x2 h2 y1fd ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y1fe ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y1ff ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y200 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y201 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y202 ff1 fs0 fc1 sc0 ls2 ws4"></div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf13" className="pf w0 h0" data-page-no="13">
          <div className="pc pc13 w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">19</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h3 y203 ff2 fs1 fc2 sc0 ls2 ws4">
              A<span className="_ _0"></span>u<span className="_ _0"></span>st
              <span className="_ _0"></span>ral<span className="_ _0"></span>i
              <span className="_ _0"></span>a<span className="_ _0"></span>n{" "}
              <span className="_ _0"></span>Pr<span className="_ _1"></span>i
              <span className="_ _0"></span>vac<span className="_ _1"></span>y
              <span className="_ _0"></span> R<span className="_ _0"></span>i
              <span className="_ _0"></span>g<span className="_ _0"></span>ht
              <span className="_ _0"></span>s<span className="_ _0"></span>{" "}
              <span className="_ _0"></span>(<span className="_ _0"></span>A
              <span className="_ _0"></span>P<span className="_ _0"></span>P
              <span className="_ _1"></span>Com<span className="_ _1"></span>p
              <span className="_ _0"></span>l<span className="_ _0"></span>i
              <span className="_ _0"></span>a<span className="_ _0"></span>nc
              <span className="_ _1"></span>e<span className="_ _0"></span>)
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y204 ff1 fs0 fc1 sc0 ls2 ws4">
              The Company, <span className="ff6 ws1">ChurchPlan</span>, is
              committed to c<span className="_ _2"></span>omplying with the
              <span className="_ _0"></span>
              <span className="ff6">
                Australian Pr<span className="_ _2"></span>ivacy Principles
              </span>
            </div>
            <div className="t m0 x2 h2 y205 ff6 fs0 fc1 sc0 ls2 ws1">
              (APPs)
              <span className="ff1 ws4">
                under the
                <span className="ff6">
                  Privacy Act 1988 (Ct<span className="_ _2"></span>h)
                  <span className="_ _0"></span>
                  <span className="ff1">
                    when handling the personal
                    <span className="_ _2"></span>information of Australian
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y206 ff1 fs0 fc1 sc0 ls2 ws4">
              users. This section outlines our practices in accordance with
              Australian pr<span className="_ _2"></span>ivacy laws.
            </div>
            <div className="t m0 x2 h6 y207 ff3 fs4 fc0 sc0 ls2 ws4">
              1. Open and Tr<span className="_ _0"></span>anspare
              <span className="_ _0"></span>nt Manageme
              <span className="_ _0"></span>nt of Personal Inf
              <span className="_ _0"></span>ormati
              <span className="_ _0"></span>on
            </div>
            <div className="t m0 x2 h2 y208 ff1 fs0 fc1 sc0 ls2 ws4">
              We maintain this Privacy Policy to clearly explain h
              <span className="_ _2"></span>ow we collect, use, disclose, and
              protect
            </div>
            <div className="t m0 x2 h2 y209 ff1 fs0 fc1 sc0 ls2 ws4">
              personal information. Users may req<span className="_ _2"></span>
              uest a copy of this policy at any time.
            </div>
            <div className="t m0 x2 h6 y20a ff3 fs4 fc0 sc0 ls2 ws4">
              2. Anonymity<span className="_ _0"></span> and Ps
              <span className="_ _0"></span>eudonymit
              <span className="_ _0"></span>y
            </div>
            <div className="t m0 x2 h2 y20b ff1 fs0 fc1 sc0 ls2 ws4">
              Where possible, users may <span className="_ _2"></span>interac
              <span className="_ _0"></span>t with our Serv
              <span className="_ _2"></span>ice anonymously or using a
              pseudonym. However,
            </div>
            <div className="t m0 x2 h2 y20c ff1 fs0 fc1 sc0 ls2 ws4">
              certain features (e.g., account registration, pay
              <span className="_ _2"></span>ments) may require personal
              information to funct<span className="_ _2"></span>ion
            </div>
            <div className="t m0 x2 h2 y20d ff1 fs0 fc1 sc0 ls2 ws4">
              properly.
            </div>
            <div className="t m0 x2 h6 y20e ff3 fs4 fc0 sc0 ls2 ws4">
              3. Collection o<span className="_ _0"></span>f Soli
              <span className="_ _0"></span>cited Person
              <span className="_ _0"></span>al Inform
              <span className="_ _0"></span>ation
            </div>
            <div className="t m0 x2 h2 y20f ff1 fs0 fc1 sc0 ls2 ws4">
              We only collect personal information that i
              <span className="_ _2"></span>s:
            </div>
            <div className="t m0 x6 h2 yef ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Reasonably necessary
                  <span className="ff1">
                    for our functions or activit<span className="_ _2"></span>
                    ies.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1e0 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Directly related
                  <span className="ff1">
                    to providing and improvin<span className="_ _2"></span>g the
                    Service.
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1e1 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Collected with the user’s
                  <span className="ff6 ws1">consent</span> (unless an excepti
                  <span className="_ _2"></span>on applies under Australian
                  law).
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y210 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 yd8 ff3 fs4 fc0 sc0 ls2 ws4">
              4. Dealing wi<span className="_ _0"></span>th Unsolici
              <span className="_ _0"></span>ted Personal
              <span className="_ _0"></span> Informat
              <span className="_ _0"></span>ion
            </div>
            <div className="t m0 x2 h2 yd9 ff1 fs0 fc1 sc0 ls2 ws4">
              If we receive unsolicited personal information that w
              <span className="_ _2"></span>e could not have lawfully collected,
              we will:
            </div>
            <div className="t m0 x6 h2 y211 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff6 fs0 ls2">
                  Destroy or de-identify
                  <span className="ff1">
                    the information (if lawful an<span className="_ _2"></span>d
                    reasonable).
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y3d ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  If the information could have been collected und
                  <span className="_ _2"></span>er APP 3, we will treat it in a
                  <span className="_ _2"></span>ccordance with
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y212 ff1 fs0 fc1 sc0 ls2 ws4">
              this Privacy Policy.
            </div>
            <div className="t m0 x5 h2 y3f ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y213 ff3 fs4 fc0 sc0 ls2 ws4">
              5. Notification<span className="_ _0"></span> of Colle
              <span className="_ _0"></span>ction
            </div>
            <div className="t m0 x2 h2 y214 ff1 fs0 fc1 sc0 ls2 ws4">
              At or before the time of collection (or as soon
              <span className="_ _2"></span>
              as practicable afterward), we will notify users
              <span className="_ _2"></span>of:
            </div>
            <div className="t m0 x6 h2 y215 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Our identity and contact d<span className="_ _2"></span>
                  etails.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1ce ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  The purposes for which we collect the infor
                  <span className="_ _2"></span>mation.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y216 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Any third parties to whom the infor
                  <span className="_ _2"></span>
                  mation may be disclosed.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y217 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  How users can access and correct their informati
                  <span className="_ _2"></span>on.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y218 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Whether the collection is required or author
                  <span className="_ _2"></span>ized by law.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y219 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y21a ff3 fs4 fc0 sc0 ls2 ws4">
              6. Use and Dis<span className="_ _0"></span>closure
              <span className="_ _0"></span>of Person
              <span className="_ _0"></span>al Inform
              <span className="_ _0"></span>ation
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf14" className="pf w0 h0" data-page-no="14">
          <div className="pc pc14 w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">20</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y20 ff1 fs0 fc1 sc0 ls2 ws4">
              We will only use or disclose personal
              <span className="_ _2"></span>information for the
              <span className="_ _0"></span>
              <span className="ff6">
                primary purpos<span className="_ _2"></span>e
                <span className="ff1">for which it was</span>
              </span>
            </div>
            <div className="t m0 x2 h2 y21 ff1 fs0 fc1 sc0 ls2 ws4">
              collected, or for a <span className="ff6">secondary purpose</span>{" "}
              if:
            </div>
            <div className="t m0 x6 h2 y1f1 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">The user has consented. </span>
              </span>
            </div>
            <div className="t m0 x6 h2 ya7 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  The user would reasonably <span className="_ _2"></span>expec
                  <span className="_ _0"></span>t the use/disclosure.
                  <span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 ya8 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  It is required or authorized by <span className="_ _2"></span>
                  law.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 ya9 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  It is necessary to prevent a serious threat to li
                  <span className="_ _2"></span>fe, health, or safety.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 yaa ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y21b ff3 fs4 fc0 sc0 ls2 ws4">
              7. Direct Mark<span className="_ _0"></span>eting
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y21c ff1 fs0 fc1 sc0 ls2 ws4">
              We may use personal informat<span className="_ _2"></span>ion for
              direct marketing
              <span className="ff6">
                on<span className="_ _0"></span>ly if
              </span>
              :
            </div>
            <div className="t m0 x6 h2 y8d ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  The user has consented (or would reas
                  <span className="_ _2"></span>onably expect us to do so).
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1f3 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  We provide a simple
                  <span className="ff6">opt-out mechanism</span> in every
                  marketing
                  <span className="_ _2"></span>communication.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1f4 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  The user has not previously opted out.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y21d ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y21e ff3 fs4 fc0 sc0 ls2 ws4">
              8. Cross-Bo<span className="_ _0"></span>rder Disclo
              <span className="_ _0"></span>sure of P
              <span className="_ _0"></span>
              ersonal Info<span className="_ _0"></span>rmation
            </div>
            <div className="t m0 x2 h2 yec ff1 fs0 fc1 sc0 ls2 ws4">
              If we disclose personal information to overseas rec
              <span className="_ _2"></span>ipients (e.g., service providers),
              we will take
            </div>
            <div className="t m0 x2 h2 y21f ff1 fs0 fc1 sc0 ls2 ws4">
              reasonable steps to ensure they comply wit
              <span className="_ _2"></span>h the APPs or similar privacy prot
              <span className="_ _2"></span>ections.
            </div>
            <div className="t m0 x2 h6 y220 ff3 fs4 fc0 sc0 ls2 ws4">
              9. Adoption, U<span className="_ _0"></span>se, or Di
              <span className="_ _0"></span>sclosur
              <span className="_ _0"></span>e of Gove
              <span className="_ _0"></span>rnment Id
              <span className="_ _0"></span>
              entifiers<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y221 ff1 fs0 fc1 sc0 ls2 ws4">
              We will not:
            </div>
            <div className="t m0 x6 h2 y222 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Use government-related identifier
                  <span className="_ _2"></span>s (e.g., Medicare numbers) as
                  account identifiers.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y223 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Disclose such identifiers unless required or a
                  <span className="_ _2"></span>uthorized by law.
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y1f9 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h6 y224 ff3 fs4 fc0 sc0 ls2 ws4">
              10. Data Qu<span className="_ _0"></span>ality
            </div>
            <div className="t m0 x2 h2 y225 ff1 fs0 fc1 sc0 ls2 ws4">
              We take reasonable steps to ensur<span className="_ _2"></span>e
              personal information is
              <span className="ff6">accurate, complete, and up-to-date</span>.
            </div>
            <div className="t m0 x2 h2 y226 ff1 fs0 fc1 sc0 ls2 ws4">
              Users may request corrections if their information
              <span className="_ _2"></span>is incorrect.
            </div>
            <div className="t m0 x2 h6 y227 ff3 fs4 fc0 sc0 ls2 ws4">
              11. Data Se<span className="_ _0"></span>curity
            </div>
            <div className="t m0 x2 h2 y228 ff1 fs0 fc1 sc0 ls2 ws4">
              We implement <span className="ff6">reasonable safeguards</span> to
              protect persona<span className="_ _2"></span>l information from
              misuse, interference,
            </div>
            <div className="t m0 x2 h2 y229 ff1 fs0 fc1 sc0 ls2 ws4">
              loss, unauthorized access,<span className="_ _2"></span>{" "}
              modification, or disclosure. This includes:
            </div>
            <div className="t m0 x6 h2 y22a ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Encryption and secure sto<span className="_ _2"></span>rage.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y22b ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Access controls and staff training.
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y22c ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Regular security assessments.<span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x5 h2 y22d ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y1bc ff1 fs0 fc1 sc0 ls2 ws4">
              If a data breach occurs that <span className="_ _2"></span>is
              likely to cause harm, we will notify affected ind
              <span className="_ _2"></span>ividuals and the{" "}
              <span className="_ _0"></span>
              <span className="ff6">
                O<span className="_ _0"></span>ffice{" "}
              </span>
            </div>
            <div className="t m0 x2 h2 y22e ff6 fs0 fc1 sc0 ls2 ws4">
              of the Australian Information Co<span className="_ _2"></span>
              mmissioner (OAIC)<span className="_ _0"></span>
              <span className="ff1"> as required. </span>
            </div>
            <div className="t m0 x2 h6 y22f ff3 fs4 fc0 sc0 ls2 ws4">
              12. Access<span className="_ _0"></span> to Personal I
              <span className="_ _0"></span>nformation
              <span className="_ _0"></span>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
        <div id="pf15" className="pf w0 h0" data-page-no="15">
          <div className="pc pc15 w0 h0">
            <div className="t m0 x7 h2 y1 ff1 fs0 fc0 sc0 ls2 ws4">21</div>
            <div className="t m0 x2 h2 y2 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 x2 h2 y20 ff1 fs0 fc1 sc0 ls2 ws4">
              Australian users have the <span className="_ _2"></span>right to:
            </div>
            <div className="t m0 x6 h2 y1f0 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Request access to their personal
                  <span className="_ _2"></span>information (with some
                  exceptions under law).<span className="_ _2"></span>{" "}
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y1f1 ff4 fs7 fc1 sc0 ls2 ws5">
              
              <span className="ff5 ls8 ws4">
                <span className="ff1 fs0 ls2">
                  Request corrections if the
                  <span className="_ _2"></span>information is
                  <span className="_ _0"></span>
                  inaccurate<span className="_ _2"></span>, outdated, or
                  incomplete.
                </span>
              </span>
            </div>
            <div className="t m0 x2 h2 ya7 ff1 fs0 fc1 sc0 ls2 ws4">
              Requests must be made in w<span className="_ _2"></span>riting and
              may require identity verificati<span className="_ _2"></span>on.
              We will respond within a
            </div>
            <div className="t m0 x2 h2 ya8 ff1 fs0 fc1 sc0 ls2 ws4">
              reasonable time (usually <span className="ff6">30 days</span>).
            </div>
            <div className="t m0 x2 h6 y230 ff3 fs4 fc0 sc0 ls2 ws4">
              13. Correction<span className="_ _0"></span> of Pe
              <span className="_ _0"></span>rsonal Inform
              <span className="_ _0"></span>
              ation
            </div>
            <div className="t m0 x2 h2 y231 ff1 fs0 fc1 sc0 ls2 ws4">
              If we refuse a correction request, w<span className="_ _2"></span>
              e will provide written reasons and note the
              <span className="_ _2"></span>dispute on the user’s
            </div>
            <div className="t m0 x2 h2 y8b ff1 fs0 fc1 sc0 ls2 ws4">
              record.
            </div>
            <div className="t m0 x2 h2 y232 ff6 fs0 fc1 sc0 ls2 ws4">
              Complaints and Enforce<span className="_ _2"></span>ment
              <span className="ff1"></span>
            </div>
            <div className="t m0 x2 h2 y233 ff1 fs0 fc1 sc0 ls2 ws4">
              If an Australian user believes we have breac
              <span className="_ _2"></span>hed the APPs, they may Lodge a c
              <span className="_ _2"></span>omplaint with us via:
            </div>
            <div className="t m0 x2 h2 y234 ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff6 ws1">
                Email:
                <span className="ff1 ws4">
                  <span className="fc5 ws1">
                    privacyofficer@churchplan.or<span className="_ _2"></span>g
                    <span className="fc1 ws4"></span>
                  </span>
                </span>
              </span>
            </div>
            <div className="t m0 x6 h2 y235 ff1 fs0 fc1 sc0 ls2 ws4">
              We will investigate and respond within
              <span className="ff6">30 days</span>.
            </div>
            <div className="t m0 x2 h3 y236 ff2 fs1 fc2 sc0 ls2 ws4">
              Ch<span className="_ _1"></span>a<span className="_ _0"></span>n
              <span className="_ _0"></span>ges<span className="_ _1"></span> to
              <span className="_ _0"></span> t<span className="_ _1"></span>h
              <span className="_ _0"></span>i<span className="_ _0"></span>s
              <span className="_ _0"></span>
              <span className="_ _0"></span>Pr<span className="_ _0"></span>i
              <span className="_ _0"></span>v<span className="_ _0"></span>acy
              <span className="_ _1"></span> Po<span className="_ _0"></span>l
              <span className="_ _0"></span>i<span className="_ _0"></span>cy
              <span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y237 ff1 fs0 fc1 sc0 ls2 ws4">
              We may update Our Privacy Policy fro<span className="_ _2"></span>
              m time to time. We will notify You of any changes by
              <span className="_ _2"></span>posting
            </div>
            <div className="t m0 x2 h2 y238 ff1 fs0 fc1 sc0 ls2 ws4">
              the new Privacy Policy on<span className="_ _2"></span> this page.
            </div>
            <div className="t m0 x2 h2 yd7 ff1 fs0 fc1 sc0 ls2 ws4">
              We will let You know via email and/or a pr
              <span className="_ _2"></span>ominent notice on Our Service, pri
              <span className="_ _2"></span>or to the change
            </div>
            <div className="t m0 x2 h2 y239 ff1 fs0 fc1 sc0 ls2 ws4">
              becoming effective and update the &quot;La
              <span className="_ _2"></span>st updated&quot; date at the top of
              this Privacy Policy.<span className="_ _2"></span>
            </div>
            <div className="t m0 x2 h2 y176 ff1 fs0 fc1 sc0 ls2 ws4">
              You are advised to review this Privacy Policy periodically for any
              ch<span className="_ _2"></span>anges. Changes to this Privacy
            </div>
            <div className="t m0 x2 h2 y23a ff1 fs0 fc1 sc0 ls2 ws4">
              Policy are effective when they are posted on th
              <span className="_ _2"></span>is page.
            </div>
            <div className="t m0 x2 h3 y23b ff2 fs1 fc2 sc0 ls2 ws4">
              Co<span className="_ _0"></span>nta<span className="_ _0"></span>c
              <span className="_ _1"></span>t <span className="_ _0"></span>U
              <span className="_ _0"></span>s<span className="_ _0"></span>
            </div>
            <div className="t m0 x2 h2 y23c ff1 fs0 fc1 sc0 ls2 ws4">
              If you have any questions about this Priv
              <span className="_ _2"></span>acy Policy, You can contact us:
            </div>
            <div className="t m0 x2 h2 y16 ff1 fs0 fc1 sc0 ls2 ws4">
              By email:
            </div>
            <div className="t m0 x2 h2 y23d ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff1 fc5 ws1">
                privacyofficer@churchplan.org<span className="fc1 ws4"> </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y15f ff4 fs0 fc1 sc0 ls2 ws0">
              <span className="ff5 ls1 ws4"> </span>
              <span className="ff1 fc5 ws1">
                support@churchplan.org<span className="fc1 ws4"> </span>
              </span>
            </div>
            <div className="t m0 x2 h2 y23e ff1 fs0 fc1 sc0 ls2 ws4">
              By visiting this page on o<span className="_ _2"></span>ur
              website:
            </div>
            <div className="t m0 x2 h2 y23f ff4 fs0 fc1 sc0 ls2 ws0">
              
              <span className="ff5 ls1 ws4">
                <a href="https://churchplan.org/cont" className="ff1 ls2">
                  https://churchplan.org/contact
                </a>
              </span>
            </div>
            <div className="t m0 x6 h2 y240 ff1 fs0 fc1 sc0 ls2 ws4"></div>
            <div className="t m0 xa h2 y241 ff5 fs5 fc3 sc0 ls2 ws4">
              All rights reserve<span className="_ _2"></span>d. 2025
              <span className="ff7 ws2">
                Church<span className="fc4">Plan</span>
              </span>
              <span className="fs6 ws3 v2">®</span>
              <span className="ff1 fs0 fc1"> </span>
            </div>
          </div>
          <div
            className="pi"
            data-data='{"ctm":[1.000000,0.000000,0.000000,1.000000,0.000000,0.000000]}'
          ></div>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
